import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    marginTop: 40,
    width: 'auto',
    height: 110,
    marginRight: 20
  },
  path: {
    transform: "scale(6)"
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2079.95 456.05" >
      <path fill="#171717" opacity="1.000000" stroke="none"
        d="
M519.000000,305.000000
	C346.039062,305.000000 173.578094,305.000000 1.058575,305.000000
	C1.058575,203.728683 1.058575,102.457329 1.058575,1.092985
	C267.544281,1.092985 534.088623,1.092985 800.816467,1.092985
	C800.816467,102.333069 800.816467,203.666504 800.816467,305.000000
	C707.124023,305.000000 613.312012,305.000000 519.000000,305.000000
M744.037903,114.973366
	C744.037903,114.973366 744.182617,114.993416 744.550781,114.757042
	C744.776367,114.552567 744.916443,114.300522 745.048645,113.278717
	C747.667542,107.170265 750.286438,101.061813 753.350037,94.424477
	C755.215637,89.616707 759.116455,85.120697 756.641907,79.529259
	C754.733215,75.216530 752.183899,71.187347 750.104126,66.284950
	C748.822876,60.693268 745.846497,56.824711 739.922668,55.476818
	C729.618958,53.132332 719.362976,50.578060 709.501953,48.211334
	C707.923340,49.651966 706.596313,50.862961 704.833740,51.446754
	C697.052063,49.429874 689.351318,46.951290 681.458496,45.569115
	C676.716797,44.738758 672.130737,47.003799 669.674561,51.408886
	C664.971008,59.844505 660.689026,68.515152 655.833801,77.669945
	C654.246765,80.881622 652.659729,84.093300 650.236694,87.325050
	C648.361267,87.864899 645.418823,87.832466 644.774963,89.032860
	C638.114319,101.451782 631.501404,113.919472 625.565308,126.694252
	C622.508484,133.272797 625.100708,138.535614 631.080811,140.938354
	C631.080811,140.938354 631.225891,140.892105 631.577454,141.452484
	C634.379578,142.649994 637.181763,143.847519 640.467651,145.524200
	C647.315491,148.588608 654.163269,151.653030 661.567627,155.148529
	C661.782593,155.241501 661.997559,155.334457 662.272766,155.605057
	C662.272766,155.605057 662.188843,155.772797 662.080627,156.555054
	C662.692444,157.359070 663.134705,158.489990 663.945435,158.910370
	C667.398804,160.701157 670.910767,162.401367 674.495239,163.911789
	C680.305664,166.360214 686.189758,168.633820 692.522644,171.060760
	C692.522644,171.060760 692.973267,171.243759 693.083069,171.818634
	C693.761353,171.798050 694.439575,171.777481 695.931824,171.785355
	C697.283569,171.881088 698.635315,171.976822 699.923645,172.574844
	C699.941650,172.742630 699.959717,172.910431 700.126648,173.768158
	C701.748108,175.461151 703.369568,177.154144 704.104614,178.894073
	C699.021423,180.077423 693.938293,181.260773 689.117249,182.383118
	C689.446594,180.479752 688.126953,178.912354 684.827209,179.143509
	C681.438782,179.380844 682.132751,181.873642 682.128845,183.947952
	C682.108887,194.607880 682.181213,205.268539 682.068298,215.927322
	C682.038208,218.773468 682.232300,220.750443 685.900940,220.694733
	C689.645386,220.637863 689.627502,218.420914 689.592041,215.719147
	C689.504456,209.057785 689.525757,202.394379 689.565979,195.732162
	C689.594421,191.019867 695.070068,185.252533 699.565186,185.099258
	C703.919617,184.950760 706.751099,188.740952 707.010620,195.110657
	C707.071655,196.607605 707.053162,198.108215 707.054016,199.607132
	C707.057983,206.368210 707.055786,213.129272 707.055786,220.526138
	C709.896729,220.384415 712.074646,220.275757 714.443970,220.157547
	C714.443970,212.206879 714.828979,204.861084 714.319763,197.577805
	C713.926147,191.947418 716.915527,188.872604 720.947266,186.305466
	C725.026306,183.708267 729.372192,185.274811 730.926086,189.933044
	C731.695923,192.240921 731.896790,194.814880 731.937744,197.275375
	C732.061951,204.747299 731.982666,212.222580 731.982666,220.511429
	C734.868530,219.499390 739.090027,223.342255 739.272095,217.336212
	C739.529053,208.852844 739.453186,200.343826 739.109253,191.862411
	C738.794800,184.107407 735.528870,180.543045 728.018677,177.939545
	C726.932068,175.153732 725.845459,172.367905 724.771362,169.044373
	C724.865906,168.699203 724.960449,168.354034 725.729675,167.899033
	C731.804871,161.546844 733.622803,153.412933 735.963867,145.058899
	C737.964783,141.383530 740.876465,137.910019 741.746704,133.984024
	C742.958618,128.515961 742.642822,122.709274 743.098267,116.494904
	C743.147827,116.313225 743.197388,116.131538 743.577087,115.751068
	C743.777893,115.578651 743.916199,115.365654 744.037903,114.973366
M62.231949,82.521156
	C62.537151,82.067719 62.842354,81.614288 63.712032,81.096092
	C64.083923,81.030869 64.455811,80.965645 65.548737,80.971039
	C66.145233,81.627724 67.363129,82.705116 67.245758,82.878471
	C65.236458,85.846230 62.888889,88.591675 60.963490,91.608017
	C57.869843,96.454544 54.096443,101.147476 52.293198,106.474953
	C49.207584,115.591026 47.074600,125.081581 45.283180,134.555130
	C44.666672,137.815430 46.265530,141.494644 47.023090,145.908585
	C46.967091,161.599609 46.911087,177.290619 46.096287,193.108292
	C45.418663,193.964783 44.160965,194.814850 44.151398,195.678757
	C44.029652,206.673294 43.951439,217.673859 44.280800,228.660370
	C44.319366,229.946716 46.772087,232.113098 48.249142,232.243286
	C55.643013,232.894974 63.083752,233.137833 70.510406,233.191116
	C71.999741,233.201797 73.499466,231.764999 75.000000,231.000000
	C75.000000,231.000000 74.996292,230.994385 75.829025,230.988266
	C76.551361,229.250977 77.894646,227.516724 77.903137,225.775940
	C78.036507,198.443878 77.987732,171.110962 78.010712,143.778275
	C78.013855,140.036682 78.056313,136.237564 82.129951,134.169266
	C84.312035,137.228424 86.096794,140.033661 88.188248,142.587723
	C90.949760,145.960052 93.920570,145.913818 96.851128,142.692764
	C98.637489,140.729324 100.306709,138.653488 102.173332,136.771774
	C102.903473,136.035706 104.463638,135.023041 104.891899,135.300385
	C106.031029,136.038132 107.361382,137.323181 107.535797,138.544769
	C107.998207,141.783493 107.990112,145.103470 107.993889,148.391312
	C108.022591,173.390717 107.922600,198.390915 108.141357,223.388428
	C108.163551,225.925064 110.026398,228.445602 111.003372,231.002441
	C111.003372,231.002441 111.024376,230.966660 111.125717,231.683395
	C111.944481,231.881958 112.758583,232.228973 113.582771,232.254868
	C118.697594,232.415558 124.154900,231.401962 128.857895,232.853638
	C137.753448,235.599411 141.985413,232.987946 141.027466,223.870438
	C140.958176,223.210876 141.005127,222.539154 140.997482,221.873077
	C140.665283,192.937027 140.135529,164.001038 140.128922,135.064911
	C140.127106,127.060738 135.493713,121.611168 131.459717,115.906036
	C128.297073,111.433228 123.570671,108.095871 119.769821,104.037872
	C113.437057,97.276680 105.285439,97.544395 96.190086,97.927200
	C93.455658,97.907227 90.721237,97.887253 88.033005,97.107910
	C89.654716,96.072868 91.224861,94.256187 92.907532,94.145172
	C98.603439,93.769394 104.542328,93.060745 110.005676,94.244881
	C116.120461,95.570198 122.195244,98.189865 127.586128,101.417603
	C132.487625,104.352310 136.418106,108.894348 140.866776,112.620178
	C141.359344,113.032700 142.443161,112.739250 143.191467,112.993088
	C143.191467,112.993088 143.217529,112.766441 143.135773,113.573975
	C143.810989,115.919624 144.306305,118.336365 145.199173,120.596001
	C147.011078,125.181404 149.766800,129.525116 150.784607,134.258484
	C151.952484,139.689880 151.924652,145.434326 151.952652,151.045074
	C152.065475,173.649399 152.021194,196.254684 151.966064,218.859451
	C151.960480,221.149124 151.644302,223.468109 151.197601,225.718994
	C150.652069,228.467941 151.326019,230.286743 154.926834,230.909073
	C155.611313,231.004974 156.295807,231.100876 157.169357,231.908035
	C158.487427,232.093613 159.799988,232.352448 161.124527,232.451950
	C166.559311,232.860291 172.018295,233.044083 177.425751,233.675461
	C179.952637,233.970505 181.692322,233.930511 181.990295,231.002289
	C181.990295,231.002289 181.925034,230.944641 182.741531,230.833481
	C183.163712,229.011353 183.942383,227.191269 183.952911,225.366760
	C184.057755,207.203903 183.244492,188.994919 184.283157,170.890320
	C185.228958,154.404739 185.745407,137.938568 181.248398,122.136528
	C176.869568,106.749870 169.574997,92.760422 155.768280,82.733467
	C150.277512,78.745857 145.669479,74.679321 138.801910,72.343475
	C126.352028,68.108917 114.410912,63.153061 100.897461,65.913277
	C99.633301,66.171501 98.246078,65.907845 96.924500,65.790565
	C90.573051,65.226959 84.232162,64.426826 77.869606,64.187843
	C76.267418,64.127663 74.599159,65.826614 72.180801,66.904427
	C71.113159,66.915543 70.045509,66.926659 68.530502,66.420837
	C66.711655,67.130524 64.892807,67.840202 62.332817,68.809601
	C61.552074,68.858551 60.771332,68.907494 59.540417,68.429855
	C57.096043,67.538490 55.445606,68.118324 54.366890,71.079491
	C53.731213,71.135506 53.095539,71.191513 51.666744,71.102074
	C50.782818,71.761719 49.898891,72.421356 48.410889,73.308151
	C47.280712,73.886337 46.150536,74.464516 44.552811,74.476219
	C38.923985,73.056931 37.006451,77.085030 35.001488,81.003487
	C35.001488,81.003487 34.982166,80.999580 34.251293,80.991058
	C33.186920,82.021179 32.122543,83.051300 30.989660,84.025757
	C30.989660,84.025757 31.069748,84.060867 30.323507,84.015503
	C28.602932,85.734596 26.882357,87.453690 25.000423,89.013809
	C25.000423,89.013809 25.173441,89.159538 24.420418,89.117676
	C22.136929,90.200722 19.420158,90.944641 20.148233,95.073044
	C19.445276,96.059303 18.742317,97.045563 17.341831,98.110718
	C16.530821,99.702026 15.719811,101.293343 14.477653,103.318268
	C13.994109,104.218193 13.510566,105.118126 12.320464,106.104683
	C6.750955,115.049408 3.293849,124.637436 3.356127,136.209290
	C3.294318,166.659241 3.199510,197.109299 3.288938,227.558807
	C3.292591,228.802750 5.030033,230.041611 6.168155,231.963852
	C11.752148,231.980255 17.338852,232.106689 22.919048,231.969147
	C25.948503,231.894455 28.966885,231.370575 32.393425,230.769104
	C32.660202,230.566330 32.860867,230.311508 33.733055,229.873047
	C33.824993,227.257706 33.954971,224.643051 34.002766,222.026901
	C34.342476,203.432968 34.698959,184.839249 34.975361,166.244339
	C35.071789,159.757431 35.507629,153.204559 34.775948,146.797424
	C34.117348,141.030243 34.446018,135.775757 37.088840,130.602646
	C37.724808,129.357788 37.699802,127.750748 37.870003,126.297523
	C38.224915,123.267212 38.318932,120.193398 38.874756,117.203369
	C39.383320,114.467590 40.358852,111.818619 41.780499,108.924553
	C43.203754,105.998573 44.627010,103.072601 46.221413,99.649544
	C46.487663,99.433701 46.753914,99.217857 47.819248,99.004448
	C51.843502,99.348557 50.790245,96.269196 51.780739,93.962746
	C53.129398,92.195076 54.478062,90.427406 55.998779,88.285606
	C56.166252,88.051140 56.390064,87.900253 57.446480,87.893921
	C60.059097,87.292542 62.294189,86.337502 62.231949,82.521156
M359.916138,282.227875
	C359.904083,282.397766 359.892059,282.567627 359.299500,282.794373
	C358.912170,282.763519 358.524872,282.732666 358.209045,282.333740
	C358.209045,282.333740 358.011536,282.015045 358.111755,281.412201
	C356.544830,276.897308 354.975891,272.383118 353.411804,267.867218
	C352.616760,265.571686 350.743347,264.572906 349.726532,266.989471
	C347.665222,271.888245 346.437286,277.137634 344.718109,282.470551
	C344.718109,282.470551 344.860168,282.702087 344.071716,282.766846
	C342.753693,282.757690 341.435699,282.748535 340.011047,282.158051
	C339.896851,281.997528 339.782623,281.837006 339.813446,280.796387
	C339.813446,276.663818 339.813446,272.531281 339.813446,268.532837
	C341.688995,268.087585 343.018829,267.771881 344.348663,267.456177
	C344.271484,267.047180 344.194305,266.638153 344.117126,266.229126
	C336.604156,266.229126 329.091187,266.229126 321.286133,266.229126
	C321.286133,271.449677 321.286133,276.578125 320.988983,282.201111
	C320.957397,282.390839 320.925781,282.580536 320.207458,282.779510
	C319.521912,282.745209 318.836334,282.710938 318.276062,282.322754
	C318.276062,282.322754 318.027405,282.041443 318.188599,281.240936
	C318.439819,277.604401 314.581268,274.191040 317.607025,270.217590
	C317.833557,269.920074 315.447144,266.740479 313.821960,266.151184
	C311.790710,265.414673 309.289520,265.974182 307.005768,265.974182
	C307.005768,271.488739 307.005768,276.740143 306.784058,282.327240
	C306.784058,282.327240 306.870026,282.720245 305.955322,282.774048
	C301.016632,282.750763 296.077942,282.727478 291.211365,282.284332
	C291.211365,282.284332 290.958008,281.941772 291.160492,281.082886
	C291.257141,279.135223 291.353760,277.187561 291.452942,275.188812
	C293.886566,274.863190 296.066956,274.571472 298.247314,274.279755
	C291.351349,271.760162 291.351349,271.760162 291.861389,268.336853
	C294.240906,268.067078 296.631348,267.796051 299.021759,267.525024
	C298.973450,267.108917 298.925140,266.692810 298.876862,266.276703
	C295.621399,266.276703 292.365967,266.276703 289.106384,266.276703
	C289.106384,271.650665 289.106384,276.758362 288.812256,282.206909
	C288.812256,282.206909 288.851593,282.655457 288.275940,282.724365
	C287.891541,282.730774 287.507141,282.737183 287.165466,282.339081
	C287.165466,282.339081 286.982025,281.975983 287.059540,281.194519
	C285.574188,276.991821 284.174042,272.755615 282.544434,268.609650
	C282.129333,267.553528 280.986084,266.783661 280.177368,265.882263
	C279.460052,266.670502 278.435211,267.340088 278.077576,268.267059
	C276.353210,272.736420 274.808563,277.275116 272.873260,282.150177
	C272.873260,282.150177 272.848938,282.636566 272.269440,282.701385
	C271.883759,282.722198 271.498047,282.743011 271.096161,282.258728
	C271.015625,282.110779 270.935059,281.962799 270.974365,281.118439
	C270.974365,276.090088 270.974365,271.061737 270.974365,266.033356
	C270.441437,265.811890 269.908508,265.590393 269.375610,265.368927
	C267.441254,268.048065 265.506927,270.727234 263.662231,273.282227
	C261.404694,270.490051 259.378784,267.984344 257.352844,265.478638
	C256.952850,265.785858 256.552826,266.093079 256.152802,266.400299
	C256.152802,271.536926 256.152802,276.673553 255.925354,282.262451
	C255.914108,282.430817 255.902878,282.599213 255.085114,282.828583
	C254.885895,283.139709 254.686676,283.450836 254.487457,283.761963
	C254.620728,283.820374 254.752014,283.924011 254.887558,283.929871
	C255.718689,283.966064 256.550781,283.998810 257.382538,283.998840
	C336.527710,284.001251 415.672882,284.001801 494.818054,283.978882
	C495.435364,283.978699 496.052612,283.656097 497.470093,283.260986
	C496.087494,282.945984 495.605194,282.836121 495.048889,282.177124
	C494.942657,282.026062 494.836395,281.875000 494.872742,280.833832
	C494.872742,275.922821 494.872742,271.011841 494.872742,266.100830
	C494.361603,265.841553 493.850494,265.582306 493.339355,265.323029
	C491.336334,267.939270 489.333282,270.555481 487.319977,273.185181
	C485.239685,270.550995 483.184265,267.948273 481.128815,265.345520
	C480.749084,265.619354 480.369354,265.893158 479.989624,266.166992
	C479.989624,271.449402 479.989624,276.731842 479.772217,282.331818
	C479.772217,282.331818 479.863953,282.705597 479.180054,282.766449
	C478.494476,282.754150 477.808868,282.741852 477.087891,282.198547
	C476.990143,282.050476 476.892365,281.902435 476.757629,280.999725
	C476.329163,277.568481 473.302612,274.447784 475.818512,270.521271
	C476.145172,270.011475 473.677399,266.832764 471.991547,266.143036
	C470.059387,265.352570 467.555420,265.959808 465.080353,265.959808
	C465.080353,271.589478 465.080353,276.831329 464.245972,282.634766
	C462.293488,282.466309 460.341003,282.297882 458.483917,281.356537
	C462.276672,277.841187 463.369293,273.199982 461.295715,269.379181
	C459.400452,265.886871 456.243927,265.233795 452.736816,265.862701
	C446.372101,267.003967 444.960052,274.979645 449.909210,281.525452
	C449.575836,281.925110 449.242462,282.324768 448.004089,282.761017
	C444.380310,282.744843 440.756500,282.728668 437.188354,282.277618
	C437.188354,282.277618 436.939667,281.916504 437.136261,281.057678
	C437.237671,279.108917 437.339111,277.160156 437.438385,275.252716
	C439.858032,274.862366 442.017151,274.514069 444.176270,274.165771
	C437.272400,271.836060 437.272400,271.836060 437.889069,268.314941
	C440.250641,268.042999 442.612213,267.771088 444.973785,267.499146
	C444.917114,267.180267 444.860474,266.861359 444.803802,266.542480
	C437.107025,266.542480 429.410217,266.542480 421.713440,266.542480
	C421.695251,266.861755 421.677094,267.181030 421.658905,267.500275
	C423.095764,267.834991 424.532623,268.169678 426.204407,268.559082
	C426.204407,273.169464 426.204407,277.466583 425.910553,282.191406
	C425.897400,282.363861 425.884216,282.536346 425.083496,282.781799
	C423.768524,282.757996 422.453583,282.734192 421.264465,282.452576
	C421.264465,282.452576 421.115601,282.207397 421.608032,281.470581
	C420.033417,276.935577 418.537903,272.370117 416.814148,267.892548
	C416.488007,267.045380 415.330597,266.297119 414.401886,266.017273
	C414.054474,265.912598 413.046112,267.183502 412.714325,267.982941
	C411.065643,271.955292 409.542145,275.979553 407.443970,280.098419
	C407.263428,280.088593 407.082886,280.078766 406.153198,279.783203
	C404.200531,279.783203 402.247833,279.783203 399.785645,279.783203
	C399.785645,276.924164 399.895813,274.491455 399.751831,272.073914
	C399.629883,270.027283 399.213898,267.998169 398.928040,265.961304
	C398.354980,266.023254 397.781891,266.085205 397.208801,266.147156
	C397.208801,271.358093 397.208801,276.569000 396.928925,282.236176
	C396.915955,282.414093 396.902954,282.592041 395.992981,282.813721
	C392.706543,282.778992 389.420074,282.744263 386.095856,282.174316
	C385.984772,282.034180 385.873688,281.894043 385.874512,280.905121
	C385.969666,279.298584 386.064850,277.692047 386.159241,276.098053
	C390.276154,275.733734 394.675354,276.007050 394.456299,270.331177
	C394.301056,266.307556 391.028229,265.183411 383.417023,266.315033
	C383.417023,271.407776 383.417023,276.519653 383.013123,282.110596
	C382.968170,282.314575 382.923187,282.518555 382.051758,282.752930
	C380.397461,282.746002 378.743195,282.739105 376.837921,282.278870
	C376.534180,282.181610 376.230469,282.084381 376.193207,281.136566
	C373.924286,280.462097 371.655396,279.787659 368.447083,278.833984
	C368.447083,274.760071 368.447083,270.328583 368.447083,265.897095
	C367.978302,265.930176 367.509552,265.963257 367.040771,265.996338
	C367.040771,271.311859 367.040771,276.627380 366.773407,282.286438
	C366.773407,282.286438 366.863190,282.712341 366.109100,282.783203
	C365.099457,282.778748 364.089844,282.774261 362.828491,282.323425
	C362.525909,282.210510 362.223297,282.097595 362.189392,281.083771
	C362.189392,276.048065 362.189392,271.012329 362.189392,265.976624
	C361.517365,265.983917 360.845306,265.991241 360.173279,265.998535
	C360.173279,271.261169 360.173279,276.523773 359.916138,282.227875
M244.241974,164.924377
	C238.750000,164.909225 233.252747,165.034836 227.767868,164.829880
	C224.052628,164.691055 222.711349,166.296936 222.725876,169.848770
	C222.789139,185.326538 222.855423,200.805984 222.676804,216.281998
	C222.626083,220.676041 225.359451,220.677048 228.238266,220.592926
	C231.073059,220.510101 234.506958,221.224503 234.304428,216.313263
	C234.059341,210.370087 234.246307,204.409088 234.246307,198.532806
	C240.522949,197.402084 242.599869,198.250031 245.088608,203.300339
	C246.848785,206.872162 248.286697,210.605316 249.811630,214.289963
	C252.653122,221.155670 256.470306,222.526550 264.797607,218.755722
	C260.842621,210.486435 256.898682,202.240219 252.966263,194.018127
	C254.386353,192.693985 257.177124,190.937210 258.805054,188.426453
	C265.590790,177.960754 259.029785,166.857376 244.241974,164.924377
M445.920532,167.868088
	C445.920532,185.132385 445.920532,202.396683 445.920532,220.132812
	C448.563324,220.132812 450.897736,220.132812 453.616669,220.132812
	C453.616669,213.009018 453.616669,206.420074 453.616669,199.887329
	C458.724396,199.267105 463.581299,199.204239 468.139282,198.005096
	C475.704742,196.014725 479.895935,189.759064 480.040192,181.592896
	C480.173584,174.038696 476.669922,167.661728 469.859772,166.351868
	C462.788635,164.991821 455.380768,165.338501 448.114746,165.109695
	C447.445404,165.088623 446.737091,166.304718 445.920532,167.868088
M517.997192,220.930923
	C523.005859,219.989105 528.014465,219.047287 532.583801,218.188080
	C533.896729,218.924973 535.375671,220.182816 537.029663,220.485901
	C537.754639,220.618759 539.631653,218.804688 539.634094,217.871094
	C539.659180,208.224533 539.621948,198.566788 539.150879,188.934219
	C538.880676,183.409531 535.155396,179.662674 529.951721,179.343628
	C524.476074,179.007904 518.814575,180.013397 513.387329,181.158112
	C509.653931,181.945572 508.946320,184.941483 510.330505,188.054428
	C515.499146,186.930145 520.245239,185.201553 525.046204,185.032440
	C530.846619,184.828125 532.964172,188.979248 531.591553,195.999374
	C527.461975,196.354736 523.297424,196.449203 519.228760,197.122787
	C512.499695,198.236816 508.418976,202.359863 507.930603,207.964798
	C507.355255,214.567291 509.942932,218.160599 517.997192,220.930923
M270.392242,202.243805
	C271.808136,213.972595 275.939240,219.708527 285.041901,220.642456
	C290.030304,221.154236 295.236603,220.143997 300.275696,219.370621
	C304.350555,218.745239 305.047577,215.974426 303.633698,212.406998
	C283.508301,216.148071 277.091034,213.392029 278.769775,201.478577
	C286.173950,201.478577 293.630676,201.481064 301.087372,201.477112
	C303.513885,201.475830 305.674835,201.417923 306.002747,198.040573
	C306.847992,189.334625 302.053802,181.419296 294.400513,179.325195
	C285.041290,176.764328 275.689240,180.700821 272.455566,189.216782
	C271.022369,192.991196 270.994049,197.299057 270.392242,202.243805
M628.066772,179.216476
	C616.181274,177.858063 608.553955,180.453323 605.412903,188.285538
	C603.563599,192.896683 602.932434,198.292984 603.007996,203.317291
	C603.162415,213.593246 609.212891,220.014526 618.498169,220.946533
	C630.048584,222.105927 637.753296,217.131775 640.454285,206.771667
	C643.811218,193.895691 639.266602,183.252090 628.066772,179.216476
M347.428223,187.610641
	C349.742920,186.737045 351.990509,185.465469 354.384430,185.061554
	C362.911591,183.622833 366.454712,187.186096 365.447693,195.717758
	C360.364136,196.427216 355.189056,196.671738 350.284180,197.951614
	C343.756958,199.654877 340.486847,205.024521 341.397522,211.077469
	C342.314484,217.171844 346.919281,221.314560 353.752502,220.927139
	C358.008026,220.685883 362.175323,218.888397 366.601501,217.732040
	C366.403564,222.443314 369.762268,220.727234 373.146729,219.856827
	C373.146729,211.291275 373.149078,202.821548 373.145935,194.351822
	C373.143738,188.490128 372.616150,182.622314 366.227692,180.163925
	C358.831177,177.317627 351.456940,178.248871 344.726013,182.410950
	C343.713959,183.036743 343.509247,185.290894 343.421539,186.819916
	C343.403717,187.130478 345.595703,187.567795 347.428223,187.610641
M582.247009,176.554184
	C582.755859,179.884476 580.274475,178.963547 578.491638,179.497375
	C577.337952,179.842819 575.985291,181.352646 575.797974,182.514267
	C575.649841,183.432526 576.928101,185.002350 577.963745,185.571289
	C578.996338,186.138504 580.515503,185.819977 582.259216,185.913208
	C582.259216,195.997131 582.327332,205.943085 582.216431,215.887039
	C582.184509,218.750656 582.501831,220.728531 586.081177,220.718384
	C589.615723,220.708344 589.969238,218.830475 589.927917,215.919052
	C589.786682,205.970993 589.873779,196.019699 589.873779,185.717911
	C592.427307,185.717911 594.664917,186.135056 596.618469,185.569977
	C597.902222,185.198654 598.776001,183.409805 599.833374,182.255783
	C598.769714,181.291199 597.834595,179.769867 596.613342,179.487869
	C594.603271,179.023727 592.407898,179.362015 590.347046,179.362015
	C588.955933,167.719574 590.801208,165.756439 602.660156,167.720718
	C601.544067,165.024323 601.283020,162.102646 599.818481,161.251343
	C593.414551,157.528824 584.548889,161.900574 583.018555,169.202454
	C582.577087,171.309052 582.499390,173.491898 582.247009,176.554184
M317.397797,204.397064
	C317.460083,206.394211 317.410767,208.402237 317.604187,210.386597
	C318.394135,218.491669 322.513885,221.805222 330.669495,220.991547
	C335.804504,220.479233 336.720612,219.045547 335.215210,213.877472
	C327.260956,214.913635 325.334778,214.241913 325.115051,209.281464
	C324.770752,201.509369 325.023712,193.710846 325.023712,185.739365
	C327.735077,185.739365 330.147095,186.142456 332.320831,185.596634
	C333.752533,185.237137 334.841095,183.510956 336.083313,182.396744
	C334.915802,181.389984 333.871155,179.776520 332.553802,179.509781
	C330.210754,179.035355 327.702606,179.376480 325.332336,179.376480
	C324.147949,168.303467 324.147949,168.303467 317.630280,169.693756
	C317.495483,172.682114 317.355865,175.777191 317.211670,178.973785
	C315.081665,179.263168 313.170898,179.522766 311.447144,179.756958
	C308.555115,186.485641 314.011780,185.424164 317.397858,186.169693
	C317.397858,192.127396 317.397858,197.776123 317.397797,204.397064
M566.196838,220.974945
	C571.986816,219.886002 572.432495,219.233307 570.895508,213.721451
	C569.819824,213.927139 568.712830,214.110352 567.619080,214.352997
	C563.492859,215.268417 560.936646,213.606293 560.815491,209.434387
	C560.590576,201.688049 560.751038,193.930542 560.751038,185.694702
	C563.448242,185.694702 565.973816,186.050247 568.320374,185.555939
	C569.642090,185.277496 570.668640,183.597885 571.828125,182.549454
	C570.681885,181.489090 569.666260,179.768448 568.361267,179.510193
	C565.885925,179.020279 563.244751,179.368378 560.697021,179.368378
	C560.490356,175.480804 560.327148,172.410645 560.135986,168.814545
	C557.625061,169.094711 554.291077,168.839172 554.036560,169.605942
	C553.041016,172.604538 553.019043,175.926270 552.635193,179.127914
	C552.297791,178.767929 551.960327,178.407928 551.622925,178.047943
	C549.838257,179.579269 548.053589,181.110596 546.268921,182.641907
	C548.189453,184.090591 550.109985,185.539276 553.097778,187.793015
	C553.097778,193.704300 552.975037,201.335373 553.130066,208.960770
	C553.307251,217.676941 556.541504,220.757599 566.196838,220.974945
M412.910065,164.899963
	C412.561371,160.177002 411.465332,159.684402 405.411804,161.703674
	C405.411804,179.429153 405.418915,197.229416 405.404419,215.029678
	C405.402130,217.839111 404.686279,220.822281 409.298798,220.737579
	C413.599945,220.658600 412.918640,217.856613 412.918274,215.237869
	C412.915955,198.763870 412.916504,182.289856 412.910065,164.899963
M490.254883,183.500031
	C490.254120,194.313080 490.321594,205.126846 490.207184,215.938690
	C490.176514,218.835907 490.519745,220.711136 494.110046,220.718964
	C497.819489,220.727097 497.912048,218.633972 497.900757,215.853500
	C497.831879,198.885620 497.873505,181.917313 497.851379,164.949188
	C497.849731,163.685425 497.637787,162.421906 497.482788,160.706284
	C494.917419,160.821243 492.699951,160.920609 490.603271,161.014557
	C490.445770,161.885498 490.336731,162.211700 490.335052,162.538467
	C490.300964,169.192322 490.279144,175.846237 490.254883,183.500031
M658.983887,197.836121
	C659.187744,189.419403 663.814026,185.780151 674.696960,186.280930
	C674.099609,183.856323 674.199646,180.249069 672.886353,179.627304
	C667.212708,176.941254 662.666504,180.041916 659.869934,183.346634
	C657.763062,181.643036 656.344910,179.553452 654.683777,179.338120
	C650.469666,178.791794 651.750122,182.364807 651.729980,184.551529
	C651.636414,194.677231 651.697815,204.804306 651.691711,214.930893
	C651.687988,221.144012 652.372192,221.610306 658.987488,219.560623
	C658.987488,212.687454 658.987488,205.725418 658.983887,197.836121
M385.330017,202.497681
	C385.332001,207.305832 385.483032,212.120270 385.280487,216.919800
	C385.157318,219.838837 386.481842,220.783493 389.072479,220.739227
	C391.522827,220.697388 393.004089,220.026688 392.962372,217.002899
	C392.806702,205.730789 392.819122,194.454224 392.956451,183.181610
	C392.993744,180.119537 391.839264,179.063446 388.900543,179.084167
	C386.026489,179.104416 385.231964,180.432571 385.286926,183.096130
	C385.413422,189.228043 385.328918,195.364304 385.330017,202.497681
M392.694641,171.088593
	C392.588867,168.785339 393.164398,166.065338 392.110321,164.342178
	C391.520599,163.378128 387.860687,163.387848 386.279724,164.243683
	C385.175171,164.841599 384.546326,167.786163 384.932404,169.386490
	C385.969788,173.686371 389.331451,172.029465 392.694641,171.088593
M680.387451,172.319733
	C681.397949,172.686340 682.408508,173.052948 683.419006,173.419571
	C683.519836,172.982101 683.620728,172.544647 683.721619,172.107193
	C682.652283,171.949188 681.582886,171.791183 680.387451,172.319733
z"/>
      <path fill="#B79A60" opacity="1.000000" stroke="none"
        d="
M46.855087,192.981644
	C46.911087,177.290619 46.967091,161.599609 47.224655,145.152924
	C48.592461,135.700836 49.110619,126.856407 51.055714,118.337807
	C55.527714,98.752556 66.505287,83.617058 84.254196,73.830467
	C99.224503,65.575981 114.624741,65.873787 130.495377,71.472183
	C161.922531,82.558167 180.167282,106.775726 181.700195,138.481384
	C183.187042,169.234207 181.960129,200.118240 181.925034,230.944641
	C181.925034,230.944641 181.990295,231.002289 181.504089,230.954803
	C173.005356,231.003815 164.992813,231.100296 156.980286,231.196762
	C156.295807,231.100876 155.611313,231.004974 154.536560,230.450989
	C154.113876,227.831757 154.056046,225.670670 154.052872,223.509506
	C154.011841,195.572815 154.284485,167.630600 153.779480,139.702408
	C153.599731,129.761536 150.733215,120.174873 143.217529,112.766441
	C143.217529,112.766441 143.191467,112.993088 143.203629,112.538589
	C128.858566,89.745171 91.219696,84.020508 78.982681,100.403625
	C81.984055,99.558174 84.985435,98.712723 87.986809,97.867271
	C90.721237,97.887253 93.455658,97.907227 96.871361,98.145233
	C103.059380,100.048424 108.997017,100.920349 113.993813,103.567940
	C130.399673,112.260704 138.542084,126.567757 138.789200,144.907654
	C139.156708,172.181046 138.861603,199.463028 138.947647,226.741043
	C138.958099,230.051590 137.620285,231.074234 134.475266,231.018082
	C126.660492,230.878494 118.841606,230.968719 111.024376,230.966660
	C111.024376,230.966660 111.003372,231.002441 110.965836,230.524002
	C110.902596,202.269135 110.948898,174.492203 110.761688,146.716873
	C110.737793,143.172562 110.104187,139.366333 108.679916,136.157806
	C106.353096,130.916031 104.170738,130.856049 100.516579,135.063034
	C92.638641,144.132782 92.638657,144.132782 85.339195,134.688553
	C82.067436,130.455460 80.248260,130.314941 78.185760,135.250702
	C76.448013,139.409302 75.412018,144.166168 75.358444,148.673569
	C75.032303,176.111404 75.076004,203.553619 74.996292,230.994385
	C74.996292,230.994385 75.000000,231.000000 74.529755,230.969360
	C65.469925,230.938705 56.880325,230.938705 48.010838,230.938705
	C47.693058,226.626205 47.271553,223.013351 47.190853,219.392899
	C46.994659,210.591019 46.956757,201.785629 46.855087,192.981644
z"/>
      <path fill="white" opacity="1.000000" stroke="none"
        d="
M244.702744,164.940796
	C259.029785,166.857376 265.590790,177.960754 258.805054,188.426453
	C257.177124,190.937210 254.386353,192.693985 252.966263,194.018127
	C256.898682,202.240219 260.842621,210.486435 264.797607,218.755722
	C256.470306,222.526550 252.653122,221.155670 249.811630,214.289963
	C248.286697,210.605316 246.848785,206.872162 245.088608,203.300339
	C242.599869,198.250031 240.522949,197.402084 234.246307,198.532806
	C234.246307,204.409088 234.059341,210.370087 234.304428,216.313263
	C234.506958,221.224503 231.073059,220.510101 228.238266,220.592926
	C225.359451,220.677048 222.626083,220.676041 222.676804,216.281998
	C222.855423,200.805984 222.789139,185.326538 222.725876,169.848770
	C222.711349,166.296936 224.052628,164.691055 227.767868,164.829880
	C233.252747,165.034836 238.750000,164.909225 244.702744,164.940796
M234.280060,174.845261
	C234.280060,179.421524 234.280060,183.997787 234.280060,189.250946
	C237.838486,188.940659 240.993393,189.054703 243.932281,188.312943
	C247.800919,187.336487 249.440659,184.365433 249.072235,180.377365
	C248.713440,176.493500 246.394501,174.376312 242.687988,174.008743
	C240.094498,173.751556 237.446854,174.040497 234.280060,174.845261
z"/>
      <path fill="white" opacity="1.000000" stroke="none"
        d="
M728.014160,178.676392
	C735.528870,180.543045 738.794800,184.107407 739.109253,191.862411
	C739.453186,200.343826 739.529053,208.852844 739.272095,217.336212
	C739.090027,223.342255 734.868530,219.499390 731.982666,220.511429
	C731.982666,212.222580 732.061951,204.747299 731.937744,197.275375
	C731.896790,194.814880 731.695923,192.240921 730.926086,189.933044
	C729.372192,185.274811 725.026306,183.708267 720.947266,186.305466
	C716.915527,188.872604 713.926147,191.947418 714.319763,197.577805
	C714.828979,204.861084 714.443970,212.206879 714.443970,220.157547
	C712.074646,220.275757 709.896729,220.384415 707.055786,220.526138
	C707.055786,213.129272 707.057983,206.368210 707.054016,199.607132
	C707.053162,198.108215 707.071655,196.607605 707.010620,195.110657
	C706.751099,188.740952 703.919617,184.950760 699.565186,185.099258
	C695.070068,185.252533 689.594421,191.019867 689.565979,195.732162
	C689.525757,202.394379 689.504456,209.057785 689.592041,215.719147
	C689.627502,218.420914 689.645386,220.637863 685.900940,220.694733
	C682.232300,220.750443 682.038208,218.773468 682.068298,215.927322
	C682.181213,205.268539 682.108887,194.607880 682.128845,183.947952
	C682.132751,181.873642 681.438782,179.380844 684.827209,179.143509
	C688.126953,178.912354 689.446594,180.479752 689.117249,182.383118
	C693.938293,181.260773 699.021423,180.077423 704.860168,179.043610
	C708.203369,181.082733 710.791016,182.972321 713.584290,185.012115
	C715.756836,183.397003 718.373047,181.452103 721.386963,179.400024
	C722.852539,179.047668 723.920410,178.802505 725.360962,178.640961
	C726.493835,178.708527 727.254028,178.692459 728.014160,178.676392
z"/>
      <path fill="#53C1E3" opacity="1.000000" stroke="none"
        d="
M631.029236,140.795120
	C625.100708,138.535614 622.508484,133.272797 625.565308,126.694252
	C631.501404,113.919472 638.114319,101.451782 644.774963,89.032860
	C645.418823,87.832466 648.361267,87.864899 650.724854,87.644302
	C655.813232,91.152138 656.832581,90.660599 657.910889,84.864922
	C658.825623,79.948570 661.734436,76.714531 666.376587,74.903847
	C670.701965,73.216721 674.369202,73.648392 677.280334,77.645782
	C677.799500,78.358704 678.905640,78.644196 679.836426,79.473953
	C680.239136,81.196053 680.546204,82.571266 680.527222,84.014816
	C677.444214,87.098366 674.609680,90.050171 672.023682,93.205566
	C671.684326,93.619659 672.616821,95.076210 672.916382,96.429970
	C670.410828,97.430481 667.871216,98.750504 665.507690,98.487640
	C662.783569,98.184708 660.214905,96.484062 658.567017,95.800430
	C657.325134,99.260948 657.097534,103.602341 654.870850,105.262505
	C651.193604,108.004211 647.379700,110.401512 643.744751,113.400360
	C638.402771,117.807442 636.782043,123.188217 634.600342,128.999115
	C632.862915,128.837601 631.525146,128.675766 630.111267,128.504715
	C630.601562,126.613937 630.955566,125.337967 631.191467,124.040504
	C631.201843,123.983452 629.661499,123.534218 629.635376,123.597008
	C629.103638,124.875404 628.697510,126.205345 628.245544,127.517853
	C627.844238,128.683258 627.417786,129.840027 626.860596,131.322479
	C627.223389,133.453293 627.528687,135.352585 628.294983,137.042892
	C628.920715,138.423157 630.097046,139.553818 631.029236,140.795120
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M182.333282,230.889069
	C181.960129,200.118240 183.187042,169.234207 181.700195,138.481384
	C180.167282,106.775726 161.922531,82.558167 130.495377,71.472183
	C114.624741,65.873787 99.224503,65.575981 84.254196,73.830467
	C66.505287,83.617058 55.527714,98.752556 51.055714,118.337807
	C49.110619,126.856407 48.592461,135.700836 47.139286,144.689880
	C46.265530,141.494644 44.666672,137.815430 45.283180,134.555130
	C47.074600,125.081581 49.207584,115.591026 52.293198,106.474953
	C54.096443,101.147476 57.869843,96.454544 60.963490,91.608017
	C62.888889,88.591675 65.236458,85.846230 67.245758,82.878471
	C67.363129,82.705116 66.145233,81.627724 65.357849,80.646179
	C66.924812,78.689606 68.682671,77.057884 70.761002,75.369621
	C72.434540,74.592224 73.787613,73.871353 75.515671,73.148926
	C80.295364,71.380844 84.700058,69.614311 89.104759,67.847778
	C88.989197,67.470901 88.873634,67.094032 88.758072,66.717155
	C83.492470,66.717155 78.226860,66.717155 72.961258,66.717155
	C74.599159,65.826614 76.267418,64.127663 77.869606,64.187843
	C84.232162,64.426826 90.573051,65.226959 96.924500,65.790565
	C98.246078,65.907845 99.633301,66.171501 100.897461,65.913277
	C114.410912,63.153061 126.352028,68.108917 138.801910,72.343475
	C145.669479,74.679321 150.277512,78.745857 155.768280,82.733467
	C169.574997,92.760422 176.869568,106.749870 181.248398,122.136528
	C185.745407,137.938568 185.228958,154.404739 184.283157,170.890320
	C183.244492,188.994919 184.057755,207.203903 183.952911,225.366760
	C183.942383,227.191269 183.163712,229.011353 182.333282,230.889069
z"/>
      <path fill="white" opacity="1.000000" stroke="none"
        d="
M445.983704,167.407211
	C446.737091,166.304718 447.445404,165.088623 448.114746,165.109695
	C455.380768,165.338501 462.788635,164.991821 469.859772,166.351868
	C476.669922,167.661728 480.173584,174.038696 480.040192,181.592896
	C479.895935,189.759064 475.704742,196.014725 468.139282,198.005096
	C463.581299,199.204239 458.724396,199.267105 453.616669,199.887329
	C453.616669,206.420074 453.616669,213.009018 453.616669,220.132812
	C450.897736,220.132812 448.563324,220.132812 445.920532,220.132812
	C445.920532,202.396683 445.920532,185.132385 445.983704,167.407211
M453.555084,185.480255
	C453.555084,187.905090 453.555084,190.329941 453.555084,192.931366
	C460.288055,193.004623 466.798431,194.142105 470.555756,187.520004
	C472.838806,183.496170 472.865051,179.080826 469.980652,175.275986
	C465.760773,169.709442 459.643158,171.450989 453.554016,171.130341
	C453.554016,175.921158 453.554016,180.205795 453.555084,185.480255
z"/>
      <path fill="white" opacity="1.000000" stroke="none"
        d="
M517.581787,220.860382
	C509.942932,218.160599 507.355255,214.567291 507.930603,207.964798
	C508.418976,202.359863 512.499695,198.236816 519.228760,197.122787
	C523.297424,196.449203 527.461975,196.354736 531.591553,195.999374
	C532.964172,188.979248 530.846619,184.828125 525.046204,185.032440
	C520.245239,185.201553 515.499146,186.930145 510.330505,188.054428
	C508.946320,184.941483 509.653931,181.945572 513.387329,181.158112
	C518.814575,180.013397 524.476074,179.007904 529.951721,179.343628
	C535.155396,179.662674 538.880676,183.409531 539.150879,188.934219
	C539.621948,198.566788 539.659180,208.224533 539.634094,217.871094
	C539.631653,218.804688 537.754639,220.618759 537.029663,220.485901
	C535.375671,220.182816 533.896729,218.924973 532.583801,218.188080
	C528.014465,219.047287 523.005859,219.989105 517.581787,220.860382
M528.488037,213.101654
	C533.031433,210.592239 532.557861,206.489014 531.923889,201.506470
	C527.821350,201.982208 523.700195,202.046219 519.814575,203.035446
	C516.414429,203.901062 514.794922,206.719711 515.599182,210.375443
	C516.363464,213.849625 518.892822,215.312607 522.195129,215.104263
	C524.097107,214.984253 525.950928,214.100830 528.488037,213.101654
z"/>
      <path fill="white" opacity="1.000000" stroke="none"
        d="
M270.360107,201.804291
	C270.994049,197.299057 271.022369,192.991196 272.455566,189.216782
	C275.689240,180.700821 285.041290,176.764328 294.400513,179.325195
	C302.053802,181.419296 306.847992,189.334625 306.002747,198.040573
	C305.674835,201.417923 303.513885,201.475830 301.087372,201.477112
	C293.630676,201.481064 286.173950,201.478577 278.769775,201.478577
	C277.091034,213.392029 283.508301,216.148071 303.633698,212.406998
	C305.047577,215.974426 304.350555,218.745239 300.275696,219.370621
	C295.236603,220.143997 290.030304,221.154236 285.041901,220.642456
	C275.939240,219.708527 271.808136,213.972595 270.360107,201.804291
M295.402832,186.998795
	C286.952271,181.544601 279.224762,185.475159 278.380402,195.750534
	C284.972351,195.750534 291.553986,195.750534 299.187469,195.750534
	C297.953247,192.646835 296.950806,190.125946 295.402832,186.998795
z"/>
      <path fill="white" opacity="1.000000" stroke="none"
        d="
M628.438232,179.358200
	C639.266602,183.252090 643.811218,193.895691 640.454285,206.771667
	C637.753296,217.131775 630.048584,222.105927 618.498169,220.946533
	C609.212891,220.014526 603.162415,213.593246 603.007996,203.317291
	C602.932434,198.292984 603.563599,192.896683 605.412903,188.285538
	C608.553955,180.453323 616.181274,177.858063 628.438232,179.358200
M617.662415,185.744812
	C610.135803,188.168228 609.080322,200.538055 611.615112,207.657654
	C613.332825,212.482361 616.851746,214.806656 621.829895,214.835922
	C626.793274,214.865112 630.748108,212.696121 632.098633,207.816147
	C633.089355,204.235901 633.558838,200.288727 633.210815,196.604233
	C632.318970,187.162247 627.762329,183.952652 617.662415,185.744812
z"/>
      <path fill="white" opacity="1.000000" stroke="none"
        d="
M347.098572,187.778656
	C345.595703,187.567795 343.403717,187.130478 343.421539,186.819916
	C343.509247,185.290894 343.713959,183.036743 344.726013,182.410950
	C351.456940,178.248871 358.831177,177.317627 366.227692,180.163925
	C372.616150,182.622314 373.143738,188.490128 373.145935,194.351822
	C373.149078,202.821548 373.146729,211.291275 373.146729,219.856827
	C369.762268,220.727234 366.403564,222.443314 366.601501,217.732040
	C362.175323,218.888397 358.008026,220.685883 353.752502,220.927139
	C346.919281,221.314560 342.314484,217.171844 341.397522,211.077469
	C340.486847,205.024521 343.756958,199.654877 350.284180,197.951614
	C355.189056,196.671738 360.364136,196.427216 365.447693,195.717758
	C366.454712,187.186096 362.911591,183.622833 354.384430,185.061554
	C351.990509,185.465469 349.742920,186.737045 347.098572,187.778656
M356.370209,215.188828
	C363.441864,213.931686 367.905090,209.844681 365.187012,201.741028
	C361.995361,201.895660 358.645630,201.750626 355.412201,202.295670
	C351.718994,202.918259 348.759674,204.828400 348.968384,209.221069
	C349.161926,213.293991 351.721405,215.014404 356.370209,215.188828
z"/>
      <path fill="#EBB45B" opacity="1.000000" stroke="none"
        d="
M656.232117,77.088272
	C660.689026,68.515152 664.971008,59.844505 669.674561,51.408886
	C672.130737,47.003799 676.716797,44.738758 681.458496,45.569115
	C689.351318,46.951290 697.052063,49.429874 704.985596,52.140530
	C703.192993,56.727543 701.248657,60.620781 699.210999,64.089401
	C698.601624,61.665646 698.085632,59.666500 697.856873,58.780224
	C699.866821,57.141720 701.507446,55.804333 703.148010,54.466949
	C702.938416,53.939911 702.728821,53.412872 702.519165,52.885830
	C700.154724,52.627167 697.245117,51.380051 695.541443,52.319595
	C692.194824,54.165291 692.213684,57.609558 693.967041,60.998478
	C695.617615,64.188805 694.116272,70.820969 690.711731,72.803299
	C691.162415,69.342873 691.670715,66.469162 691.839844,63.575642
	C691.897705,62.584450 691.237854,61.448051 690.615051,60.588749
	C690.447144,60.356998 688.860535,60.663288 688.547974,61.135166
	C688.007080,61.951691 687.673950,63.117958 687.768738,64.087135
	C687.875916,65.183823 688.550476,66.225021 689.021729,67.398468
	C685.277100,66.274452 682.124023,65.328003 678.970947,64.381554
	C678.828491,64.855118 678.686096,65.328682 678.543701,65.802246
	C682.872864,69.656021 682.822510,70.176079 677.472290,73.068138
	C675.148315,71.809196 673.185242,70.617813 670.596680,69.046867
	C667.080017,71.575539 663.255371,74.436340 659.284851,77.077751
	C658.577820,77.548096 657.265137,77.107979 656.232117,77.088272
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M75.412659,230.991333
	C75.076004,203.553619 75.032303,176.111404 75.358444,148.673569
	C75.412018,144.166168 76.448013,139.409302 78.185760,135.250702
	C80.248260,130.314941 82.067436,130.455460 85.339195,134.688553
	C92.638657,144.132782 92.638641,144.132782 100.516579,135.063034
	C104.170738,130.856049 106.353096,130.916031 108.679916,136.157806
	C110.104187,139.366333 110.737793,143.172562 110.761688,146.716873
	C110.948898,174.492203 110.902596,202.269135 110.981689,230.509583
	C110.026398,228.445602 108.163551,225.925064 108.141357,223.388428
	C107.922600,198.390915 108.022591,173.390717 107.993889,148.391312
	C107.990112,145.103470 107.998207,141.783493 107.535797,138.544769
	C107.361382,137.323181 106.031029,136.038132 104.891899,135.300385
	C104.463638,135.023041 102.903473,136.035706 102.173332,136.771774
	C100.306709,138.653488 98.637489,140.729324 96.851128,142.692764
	C93.920570,145.913818 90.949760,145.960052 88.188248,142.587723
	C86.096794,140.033661 84.312035,137.228424 82.129951,134.169266
	C78.056313,136.237564 78.013855,140.036682 78.010712,143.778275
	C77.987732,171.110962 78.036507,198.443878 77.903137,225.775940
	C77.894646,227.516724 76.551361,229.250977 75.412659,230.991333
z"/>
      <path fill="white" opacity="1.000000" stroke="none"
        d="
M582.250977,176.096985
	C582.499390,173.491898 582.577087,171.309052 583.018555,169.202454
	C584.548889,161.900574 593.414551,157.528824 599.818481,161.251343
	C601.283020,162.102646 601.544067,165.024323 602.660156,167.720718
	C590.801208,165.756439 588.955933,167.719574 590.347046,179.362015
	C592.407898,179.362015 594.603271,179.023727 596.613342,179.487869
	C597.834595,179.769867 598.769714,181.291199 599.833374,182.255768
	C598.776001,183.409805 597.902222,185.198654 596.618469,185.569977
	C594.664917,186.135056 592.427307,185.717911 589.873779,185.717911
	C589.873779,196.019699 589.786682,205.970993 589.927917,215.919052
	C589.969238,218.830475 589.615723,220.708344 586.081177,220.718384
	C582.501831,220.728531 582.184509,218.750656 582.216431,215.887039
	C582.327332,205.943085 582.259216,195.997131 582.259216,185.913208
	C580.515503,185.819977 578.996338,186.138504 577.963745,185.571289
	C576.928101,185.002350 575.649841,183.432526 575.797974,182.514267
	C575.985291,181.352646 577.337952,179.842819 578.491638,179.497375
	C580.274475,178.963547 582.755859,179.884476 582.250977,176.096985
z"/>
      <path fill="#C1AB80" opacity="1.000000" stroke="none"
        d="
M32.995419,230.004608
	C32.860867,230.311508 32.660202,230.566330 31.724775,230.889832
	C22.690649,231.101318 14.325171,231.192078 5.959695,231.282852
	C5.030033,230.041611 3.292591,228.802750 3.288938,227.558807
	C3.199510,197.109299 3.294318,166.659241 3.692061,135.586273
	C4.671593,132.970673 5.315191,130.978088 6.240577,129.219360
	C9.206018,133.022858 6.112652,136.325180 6.093013,139.725800
	C5.925786,168.683655 6.016554,197.642944 5.950816,226.601624
	C5.944785,229.258652 7.002244,230.107803 9.508927,230.051376
	C14.166554,229.946503 18.849840,229.747910 23.482092,230.107758
	C27.825439,230.445160 29.156942,229.107208 29.125643,224.605377
	C28.921999,195.315094 29.088240,166.022385 28.951715,136.731323
	C28.934275,132.989212 29.644476,130.241409 33.509583,129.288559
	C33.143009,133.942413 32.236092,138.205734 32.215004,142.473434
	C32.079491,169.900864 32.122242,197.329285 32.169838,224.757278
	C32.172874,226.506851 32.707886,228.255524 32.995419,230.004608
z"/>
      <path fill="#B469E7" opacity="1.000000" stroke="none"
        d="
M699.304321,64.514023
	C701.248657,60.620781 703.192993,56.727543 705.203369,52.454132
	C706.596313,50.862961 707.923340,49.651966 709.501953,48.211334
	C719.362976,50.578060 729.618958,53.132332 739.922668,55.476818
	C745.846497,56.824711 748.822876,60.693268 749.700684,66.653572
	C748.882996,67.044792 748.468689,67.067390 748.000122,66.759995
	C747.299011,65.951508 746.652161,65.473015 745.966797,64.636322
	C743.286743,58.508850 738.550903,56.230320 732.105957,57.986324
	C735.182190,59.923691 737.990906,61.692551 741.235046,63.735645
	C739.791016,65.602119 738.524719,67.238823 736.723572,69.566841
	C736.119873,66.699593 735.761414,64.997040 735.295776,62.785606
	C726.847290,63.413872 722.085571,70.786087 714.630005,72.900185
	C713.668762,72.109268 712.954163,71.467438 712.117065,70.479568
	C708.525513,65.842308 703.764099,67.211823 699.219238,66.870979
	C699.131165,66.002274 699.133301,65.500313 699.221069,64.892410
	C699.306702,64.786469 699.304321,64.514023 699.304321,64.514023
z"/>
      <path fill="white" opacity="1.000000" stroke="none"
        d="
M317.397827,203.910950
	C317.397858,197.776123 317.397858,192.127396 317.397858,186.169693
	C314.011780,185.424164 308.555115,186.485641 311.447144,179.756958
	C313.170898,179.522766 315.081665,179.263168 317.211670,178.973785
	C317.355865,175.777191 317.495483,172.682114 317.630280,169.693756
	C324.147949,168.303467 324.147949,168.303467 325.332336,179.376480
	C327.702606,179.376480 330.210754,179.035355 332.553802,179.509781
	C333.871155,179.776520 334.915802,181.389984 336.083313,182.396744
	C334.841095,183.510956 333.752533,185.237137 332.320831,185.596634
	C330.147095,186.142456 327.735077,185.739365 325.023712,185.739365
	C325.023712,193.710846 324.770752,201.509369 325.115051,209.281464
	C325.334778,214.241913 327.260956,214.913635 335.215210,213.877472
	C336.720612,219.045547 335.804504,220.479233 330.669495,220.991547
	C322.513885,221.805222 318.394135,218.491669 317.604187,210.386597
	C317.410767,208.402237 317.460083,206.394211 317.397827,203.910950
z"/>
      <path fill="white" opacity="1.000000" stroke="none"
        d="
M565.771973,221.006744
	C556.541504,220.757599 553.307251,217.676941 553.130066,208.960770
	C552.975037,201.335373 553.097778,193.704300 553.097778,187.793015
	C550.109985,185.539276 548.189453,184.090591 546.268921,182.641907
	C548.053589,181.110596 549.838257,179.579269 551.622925,178.047943
	C551.960327,178.407928 552.297791,178.767929 552.635193,179.127914
	C553.019043,175.926270 553.041016,172.604538 554.036560,169.605942
	C554.291077,168.839172 557.625061,169.094711 560.135986,168.814545
	C560.327148,172.410645 560.490356,175.480804 560.697021,179.368378
	C563.244751,179.368378 565.885925,179.020279 568.361267,179.510193
	C569.666260,179.768448 570.681885,181.489090 571.828125,182.549469
	C570.668640,183.597885 569.642090,185.277496 568.320374,185.555939
	C565.973816,186.050247 563.448242,185.694702 560.751038,185.694702
	C560.751038,193.930542 560.590576,201.688049 560.815491,209.434387
	C560.936646,213.606293 563.492859,215.268417 567.619080,214.352997
	C568.712830,214.110352 569.819824,213.927139 570.895508,213.721451
	C572.432495,219.233307 571.986816,219.886002 565.771973,221.006744
z"/>
      <path fill="white" opacity="1.000000" stroke="none"
        d="
M412.913086,165.357910
	C412.916504,182.289856 412.915955,198.763870 412.918274,215.237869
	C412.918640,217.856613 413.599945,220.658600 409.298798,220.737579
	C404.686279,220.822281 405.402130,217.839111 405.404419,215.029678
	C405.418915,197.229416 405.411804,179.429153 405.411804,161.703674
	C411.465332,159.684402 412.561371,160.177002 412.913086,165.357910
z"/>
      <path fill="white" opacity="1.000000" stroke="none"
        d="
M490.254883,183.000092
	C490.279144,175.846237 490.300964,169.192322 490.335052,162.538467
	C490.336731,162.211700 490.445770,161.885498 490.603271,161.014557
	C492.699951,160.920609 494.917419,160.821243 497.482788,160.706284
	C497.637787,162.421906 497.849731,163.685425 497.851379,164.949188
	C497.873505,181.917313 497.831879,198.885620 497.900757,215.853500
	C497.912048,218.633972 497.819489,220.727097 494.110046,220.718964
	C490.519745,220.711136 490.176514,218.835907 490.207184,215.938690
	C490.321594,205.126846 490.254120,194.313080 490.254883,183.000092
z"/>
      <path fill="white" opacity="1.000000" stroke="none"
        d="
M658.985718,198.299759
	C658.987488,205.725418 658.987488,212.687454 658.987488,219.560623
	C652.372192,221.610306 651.687988,221.144012 651.691711,214.930893
	C651.697815,204.804306 651.636414,194.677231 651.729980,184.551529
	C651.750122,182.364807 650.469666,178.791794 654.683777,179.338120
	C656.344910,179.553452 657.763062,181.643036 659.869934,183.346634
	C662.666504,180.041916 667.212708,176.941254 672.886353,179.627304
	C674.199646,180.249069 674.099609,183.856323 674.696960,186.280930
	C663.814026,185.780151 659.187744,189.419403 658.985718,198.299759
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M111.075043,231.325027
	C118.841606,230.968719 126.660492,230.878494 134.475266,231.018082
	C137.620285,231.074234 138.958099,230.051590 138.947647,226.741043
	C138.861603,199.463028 139.156708,172.181046 138.789200,144.907654
	C138.542084,126.567757 130.399673,112.260704 113.993813,103.567940
	C108.997017,100.920349 103.059380,100.048424 97.321213,98.063423
	C105.285439,97.544395 113.437057,97.276680 119.769821,104.037872
	C123.570671,108.095871 128.297073,111.433228 131.459717,115.906036
	C135.493713,121.611168 140.127106,127.060738 140.128922,135.064911
	C140.135529,164.001038 140.665283,192.937027 140.997482,221.873077
	C141.005127,222.539154 140.958176,223.210876 141.027466,223.870438
	C141.985413,232.987946 137.753448,235.599411 128.857895,232.853638
	C124.154900,231.401962 118.697594,232.415558 113.582771,232.254868
	C112.758583,232.228973 111.944481,231.881958 111.075043,231.325027
z"/>
      <path fill="#E9B274" opacity="1.000000" stroke="none"
        d="
M725.054932,168.008850
	C724.960449,168.354034 724.865906,168.699203 724.485779,169.453644
	C723.448364,170.567978 722.696533,171.273056 721.670898,171.766327
	C720.848267,169.161758 719.045898,165.982559 719.968018,164.512604
	C723.927673,158.201004 718.838257,151.665710 721.240601,145.387985
	C719.902283,146.544235 719.621216,147.981125 718.975037,149.228928
	C717.086182,152.876404 715.051636,156.448425 713.047852,159.705414
	C713.002441,158.901443 712.983459,158.442093 712.978210,157.652786
	C713.005981,156.882706 713.019958,156.442596 713.297363,155.786835
	C714.382324,153.720413 715.203918,151.869659 716.038086,149.655640
	C716.076111,148.565903 716.101562,147.839432 716.468079,147.015594
	C717.237183,145.643280 717.665161,144.368301 718.428589,143.042206
	C719.500244,141.994461 720.236511,140.997818 721.125244,139.682159
	C723.894165,133.603912 726.510742,127.844688 729.363464,121.831810
	C729.883667,120.700981 730.167725,119.823799 730.747742,118.952347
	C731.509094,119.300240 731.974548,119.642403 732.369263,120.335526
	C734.233032,122.295189 736.167542,123.903885 738.264038,125.772781
	C738.354736,126.632591 738.283508,127.232208 737.920898,127.882797
	C737.433044,127.945572 737.236511,127.957359 736.899109,127.665115
	C735.649780,126.842705 734.419434,125.765221 733.469421,125.972588
	C732.620972,126.157768 731.688354,127.687454 731.487366,128.754700
	C731.042786,131.114700 731.408386,133.659546 730.780090,135.946747
	C728.784241,143.212601 726.266541,150.340820 724.452209,157.646851
	C723.988281,159.515060 725.377991,161.843597 725.925598,164.310898
	C725.641724,165.777039 725.348328,166.892944 725.054932,168.008850
z"/>
      <path fill="#40BEE3" opacity="1.000000" stroke="none"
        d="
M631.055054,140.866730
	C630.097046,139.553818 628.920715,138.423157 628.294983,137.042892
	C627.528687,135.352585 627.223389,133.453293 627.211670,131.359451
	C630.692139,133.745773 633.679810,136.416992 636.667419,139.088211
	C636.986755,138.806244 637.306152,138.524292 637.625549,138.242340
	C637.415405,137.159317 637.205261,136.076309 637.116089,134.727814
	C637.822327,133.971970 638.407654,133.481613 639.350769,133.058228
	C641.637329,138.120392 644.677734,140.003265 650.270325,138.235886
	C652.584351,137.504593 655.631348,139.092743 658.725525,139.700821
	C659.023865,139.321671 659.898682,138.209793 660.558899,137.370636
	C661.147278,139.230301 661.587830,140.622650 662.153564,142.313919
	C662.252075,143.354507 662.534485,144.425201 662.150208,144.786163
	C658.921265,147.819412 658.677795,151.096176 661.011108,154.717438
	C654.163269,151.653030 647.315491,148.588608 640.036743,144.988800
	C637.564087,141.497894 634.689941,140.500992 631.225891,140.892105
	C631.225891,140.892105 631.080811,140.938354 631.055054,140.866730
z"/>
      <path fill="white" opacity="1.000000" stroke="none"
        d="
M385.330017,201.998245
	C385.328918,195.364304 385.413422,189.228043 385.286926,183.096130
	C385.231964,180.432571 386.026489,179.104416 388.900543,179.084167
	C391.839264,179.063446 392.993744,180.119537 392.956451,183.181610
	C392.819122,194.454224 392.806702,205.730789 392.962372,217.002899
	C393.004089,220.026688 391.522827,220.697388 389.072479,220.739227
	C386.481842,220.783493 385.157318,219.838837 385.280487,216.919800
	C385.483032,212.120270 385.332001,207.305832 385.330017,201.998245
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M33.364235,229.938828
	C32.707886,228.255524 32.172874,226.506851 32.169838,224.757278
	C32.122242,197.329285 32.079491,169.900864 32.215004,142.473434
	C32.236092,138.205734 33.143009,133.942413 33.679070,128.948425
	C33.773216,127.471565 33.828583,126.723366 34.184845,125.759018
	C35.990803,120.696869 37.495865,115.850876 39.000618,111.002594
	C39.000305,111.000305 39.004475,110.999245 39.264137,110.873520
	C39.999260,110.153229 40.474716,109.558655 40.995705,109.004929
	C41.041233,109.045776 41.128616,109.131393 41.128616,109.131393
	C40.358852,111.818619 39.383320,114.467590 38.874756,117.203369
	C38.318932,120.193398 38.224915,123.267212 37.870003,126.297523
	C37.699802,127.750748 37.724808,129.357788 37.088840,130.602646
	C34.446018,135.775757 34.117348,141.030243 34.775948,146.797424
	C35.507629,153.204559 35.071789,159.757431 34.975361,166.244339
	C34.698959,184.839249 34.342476,203.432968 34.002766,222.026901
	C33.954971,224.643051 33.824993,227.257706 33.364235,229.938828
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M143.176651,113.170212
	C150.733215,120.174873 153.599731,129.761536 153.779480,139.702408
	C154.284485,167.630600 154.011841,195.572815 154.052872,223.509506
	C154.056046,225.670670 154.113876,227.831757 154.190002,230.452408
	C151.326019,230.286743 150.652069,228.467941 151.197601,225.718994
	C151.644302,223.468109 151.960480,221.149124 151.966064,218.859451
	C152.021194,196.254684 152.065475,173.649399 151.952652,151.045074
	C151.924652,145.434326 151.952484,139.689880 150.784607,134.258484
	C149.766800,129.525116 147.011078,125.181404 145.199173,120.596001
	C144.306305,118.336365 143.810989,115.919624 143.176651,113.170212
z"/>
      <path fill="#ECC093" opacity="1.000000" stroke="none"
        d="
M713.074219,160.050018
	C715.051636,156.448425 717.086182,152.876404 718.975037,149.228928
	C719.621216,147.981125 719.902283,146.544235 721.240601,145.387985
	C718.838257,151.665710 723.927673,158.201004 719.968018,164.512604
	C719.045898,165.982559 720.848267,169.161758 721.610168,172.041168
	C721.546265,173.015564 721.269226,173.503265 720.608704,174.043274
	C716.696960,174.405182 713.152039,175.078751 709.645386,174.917908
	C706.401489,174.769119 703.198669,173.726974 699.977722,173.078247
	C699.959717,172.910431 699.941650,172.742630 700.000610,171.974091
	C701.445312,170.637451 702.812988,169.901581 704.463501,169.115250
	C705.208008,168.752029 705.669800,168.439270 706.457520,168.068726
	C707.552063,167.045547 708.320679,166.080139 709.394043,164.955780
	C710.459717,163.529724 711.220703,162.262619 712.037964,160.768036
	C712.094238,160.540558 712.167175,160.077591 712.394165,160.077972
	C712.621094,160.078354 713.074158,160.050018 713.074219,160.050018
z"/>
      {/* <path fill="#363636" opacity="1.000000" stroke="none"
        d="
M291.139252,282.704224
	C296.077942,282.727478 301.016632,282.750763 306.775421,282.864319
	C308.095093,282.891327 308.594666,282.828064 309.550842,282.795227
	C311.849274,282.896545 313.691132,282.967438 315.505737,283.049408
	C315.478485,283.060516 315.438904,283.016937 315.898926,283.026672
	C316.956238,282.916504 317.553528,282.796570 318.150787,282.676666
	C318.836334,282.710938 319.521912,282.745209 321.004730,282.893738
	C324.918365,282.888702 328.034729,282.769501 331.556274,282.720093
	C333.606659,282.780731 335.251923,282.771484 337.290863,282.881226
	C338.495605,282.913269 339.306641,282.826324 340.117676,282.739380
	C341.435699,282.748535 342.753693,282.757690 344.830933,282.864868
	C346.094604,282.890625 346.599091,282.818359 347.542725,282.769348
	C350.619873,282.781647 353.257904,282.770721 356.264832,282.879456
	C357.135010,282.900055 357.636292,282.800934 358.137543,282.701813
	C358.524872,282.732666 358.912170,282.763519 359.980286,282.886932
	C361.467468,282.909576 362.273834,282.839661 363.080200,282.769775
	C364.089844,282.774261 365.099457,282.778748 366.937988,282.873962
	C370.874207,282.887207 373.981537,282.809692 377.088898,282.732178
	C378.743195,282.739105 380.397461,282.746002 382.860901,282.869629
	C384.491241,282.894043 385.312439,282.801758 386.133636,282.709503
	C389.420074,282.744263 392.706543,282.778992 396.898590,282.895508
	C401.382996,282.648438 404.961823,282.319611 408.700195,281.968292
	C408.859741,281.945770 409.182037,281.945343 409.182037,281.945343
	C409.182037,281.945343 409.501343,281.989349 409.777435,282.338074
	C413.007629,282.722809 415.961731,282.758820 419.286316,282.884766
	C420.150757,282.886597 420.644684,282.798462 421.138611,282.710358
	C422.453583,282.734192 423.768524,282.757996 425.846375,282.860352
	C427.112488,282.874542 427.615723,282.810150 428.541199,282.754425
	C430.931854,282.743286 432.900330,282.723480 435.240387,282.836304
	C436.118896,282.883453 436.625824,282.798004 437.132721,282.712524
	C440.756500,282.728668 444.380310,282.744843 448.897705,282.877869
	C452.674927,282.658447 455.558533,282.322205 458.453857,282.031189
	C458.465546,282.076447 458.388519,282.129425 458.388519,282.129425
	C460.341003,282.297882 462.293488,282.466309 464.620422,282.330261
	C464.994873,282.025757 465.033844,281.936127 464.954407,282.318115
	C465.627014,282.699036 466.379059,282.697968 467.549500,282.762878
	C469.942596,282.791016 471.917358,282.753204 474.286041,282.842987
	C475.494415,282.890259 476.308868,282.809906 477.123291,282.729553
	C477.808868,282.741852 478.494476,282.754150 479.882812,282.862335
	C481.088226,282.897675 481.590820,282.837128 482.538818,282.799927
	C485.960541,282.805267 488.936859,282.787262 492.307251,282.883667
	C493.508514,282.907440 494.315704,282.816833 495.122925,282.726257
	C495.605194,282.836121 496.087494,282.945984 497.470093,283.260986
	C496.052612,283.656097 495.435364,283.978699 494.818054,283.978882
	C415.672882,284.001801 336.527710,284.001251 257.382538,283.998840
	C256.550781,283.998810 255.718689,283.966064 254.887558,283.929871
	C254.752014,283.924011 254.620728,283.820374 254.487457,283.761963
	C254.686676,283.450836 254.885895,283.139709 255.853241,282.904877
	C257.117279,282.902771 257.613190,282.824402 258.556763,282.783295
	C262.298676,282.791473 265.592896,282.762360 269.250488,282.852234
	C270.113312,282.902069 270.612854,282.832977 271.112366,282.763855
	C271.498047,282.743011 271.883759,282.722198 272.941040,282.838013
	C274.439331,282.905304 275.266022,282.835938 276.533020,282.790070
	C279.617767,282.801758 282.262238,282.790009 285.272034,282.880920
	C286.132477,282.903564 286.627625,282.823578 287.122742,282.743591
	C287.507141,282.737183 287.891541,282.730774 288.928955,282.843506
	C290.101044,282.876526 290.620148,282.790375 291.139252,282.704224
z"/> */}
      <path fill="#9B52E0" opacity="1.000000" stroke="none"
        d="
M752.905396,94.953346
	C750.286438,101.061813 747.667542,107.170265 744.822144,113.755692
	C744.362793,114.434608 744.225159,114.688194 744.182617,114.993416
	C744.182617,114.993416 744.037903,114.973366 743.785095,115.065659
	C743.195984,115.334969 743.100891,115.598938 743.246948,115.949860
	C743.197388,116.131538 743.147827,116.313225 742.728760,116.767639
	C741.944397,117.052338 741.529602,117.064301 740.844116,116.954269
	C740.051941,116.554100 739.530457,116.275909 739.009399,115.752014
	C739.009827,115.506317 739.019043,115.015015 739.381592,114.949783
	C743.256897,107.919319 745.772034,100.739861 745.438782,92.738647
	C745.282715,88.991447 743.879822,86.970444 740.018188,86.642136
	C740.676331,84.858337 741.330811,83.424965 742.133911,81.752182
	C742.832764,81.025543 743.383179,80.538300 744.302734,80.074036
	C746.437195,82.017288 748.666748,83.691139 749.849731,85.920372
	C751.320374,88.691444 751.926086,91.921501 752.905396,94.953346
z"/>
      <path fill="#E99F1A" opacity="1.000000" stroke="none"
        d="
M704.180664,169.165710
	C702.812988,169.901581 701.445312,170.637451 700.032349,171.722931
	C698.635315,171.976822 697.283569,171.881088 695.551453,171.574417
	C695.171082,171.363480 695.178650,170.965897 695.391113,170.732559
	C693.359680,169.685944 691.115784,168.872665 688.671448,168.034302
	C688.192444,167.933548 687.990173,167.765869 687.780762,167.151596
	C685.323853,165.116837 682.950439,163.436646 680.796143,161.911530
	C684.214478,158.815216 687.517761,155.823181 691.381592,152.323395
	C693.140564,154.925385 695.423401,156.823975 695.621948,158.920059
	C695.977173,162.669174 698.033508,163.552475 701.115662,164.307129
	C702.175476,165.743210 703.105896,166.883377 704.051514,168.311737
	C704.104675,168.788513 704.142639,168.977112 704.180664,169.165710
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M88.009903,97.487595
	C84.985435,98.712723 81.984055,99.558174 78.982681,100.403625
	C91.219696,84.020508 128.858566,89.745171 143.234283,112.428650
	C142.443161,112.739250 141.359344,113.032700 140.866776,112.620178
	C136.418106,108.894348 132.487625,104.352310 127.586128,101.417603
	C122.195244,98.189865 116.120461,95.570198 110.005676,94.244881
	C104.542328,93.060745 98.603439,93.769394 92.907532,94.145172
	C91.224861,94.256187 89.654716,96.072868 88.009903,97.487595
z"/>
      <path fill="#9138DD" opacity="1.000000" stroke="none"
        d="
M753.127686,94.688904
	C751.926086,91.921501 751.320374,88.691444 749.849731,85.920372
	C748.666748,83.691139 746.437195,82.017288 744.321106,79.786911
	C743.982239,79.285774 743.994324,79.094749 744.209229,78.823593
	C744.671082,78.568855 744.814453,78.325989 744.862915,77.765991
	C744.883728,77.517120 744.880676,77.017654 744.952942,76.652054
	C746.034973,73.220963 747.044678,70.155487 748.054382,67.089996
	C748.468689,67.067390 748.882996,67.044792 749.608398,67.027145
	C752.183899,71.187347 754.733215,75.216530 756.641907,79.529259
	C759.116455,85.120697 755.215637,89.616707 753.127686,94.688904
z"/>
      {/* <path fill="white" opacity="1.000000" stroke="none"
        d="
M321.286133,281.706573
	C321.286133,276.578125 321.286133,271.449677 321.286133,266.229126
	C329.091187,266.229126 336.604156,266.229126 344.117126,266.229126
	C344.194305,266.638153 344.271484,267.047180 344.348663,267.456177
	C343.018829,267.771881 341.688995,268.087585 339.813446,268.532837
	C339.813446,272.531281 339.813446,276.663818 339.453217,281.270447
	C338.527405,281.735840 337.961792,281.727142 337.300049,281.279419
	C337.203857,276.738159 337.203857,272.635956 337.203857,268.632507
	C326.972168,266.500061 323.669525,267.543823 324.541656,272.426514
	C326.722137,272.580597 328.903931,272.734772 331.085724,272.888916
	C331.098541,273.370667 331.111389,273.852386 331.124207,274.334106
	C328.868256,274.613586 326.612305,274.893036 324.140167,275.199249
	C324.140167,276.622589 324.140167,278.052734 324.140167,279.820435
	C326.288605,279.820435 328.278168,279.692505 330.223511,279.928772
	C330.610748,279.975830 330.828674,281.416595 330.678619,282.116394
	C327.250427,281.914246 324.268280,281.810425 321.286133,281.706573
z"/> */}
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M46.475685,193.044968
	C46.956757,201.785629 46.994659,210.591019 47.190853,219.392899
	C47.271553,223.013351 47.693058,226.626205 48.010838,230.938705
	C56.880325,230.938705 65.469925,230.938705 74.526962,230.967148
	C73.499466,231.764999 71.999741,233.201797 70.510406,233.191116
	C63.083752,233.137833 55.643013,232.894974 48.249142,232.243286
	C46.772087,232.113098 44.319366,229.946716 44.280800,228.660370
	C43.951439,217.673859 44.029652,206.673294 44.151398,195.678757
	C44.160965,194.814850 45.418663,193.964783 46.475685,193.044968
z"/>
      <path fill="#D28E2D" opacity="1.000000" stroke="none"
        d="
M662.188843,155.772797
	C662.188843,155.772797 662.272766,155.605057 662.496277,155.263184
	C666.153809,147.909363 669.587830,140.897400 673.263062,133.918182
	C673.504272,133.950912 673.990723,133.937027 674.319580,133.957031
	C675.087463,133.994385 675.526489,134.011734 675.971924,134.271332
	C675.978333,134.513611 675.990234,134.998169 675.990234,135.422897
	C674.327637,142.870270 672.688782,149.898788 670.954529,156.903687
	C670.825562,157.424454 670.012817,157.775940 669.161865,158.289276
	C666.600098,157.505890 664.394470,156.639328 662.188843,155.772797
z"/>
      <path fill="#C1AB80" opacity="1.000000" stroke="none"
        d="
M656.032959,77.379112
	C657.265137,77.107979 658.577820,77.548096 659.284851,77.077751
	C663.255371,74.436340 667.080017,71.575539 670.596680,69.046867
	C673.185242,70.617813 675.148315,71.809196 677.540588,73.408150
	C678.768005,75.464485 679.566284,77.113258 680.213989,78.862518
	C680.063416,78.963005 679.740662,79.127083 679.740662,79.127075
	C678.905640,78.644196 677.799500,78.358704 677.280334,77.645782
	C674.369202,73.648392 670.701965,73.216721 666.376587,74.903847
	C661.734436,76.714531 658.825623,79.948570 657.910889,84.864922
	C656.832581,90.660599 655.813232,91.152138 651.142883,87.634262
	C652.659729,84.093300 654.246765,80.881622 656.032959,77.379112
z"/>
      {/* <path fill="white" opacity="1.000000" stroke="none"
        d="
M426.204407,281.763702
	C426.204407,277.466583 426.204407,273.169464 426.204407,268.559082
	C424.532623,268.169678 423.095764,267.834991 421.658905,267.500275
	C421.677094,267.181030 421.695251,266.861755 421.713440,266.542480
	C429.410217,266.542480 437.107025,266.542480 444.803802,266.542480
	C444.860474,266.861359 444.917114,267.180267 444.973785,267.499146
	C442.612213,267.771088 440.250641,268.042999 437.889008,268.316925
	C437.272400,271.836060 437.272400,271.836060 444.176270,274.165771
	C442.017151,274.514069 439.858032,274.862366 437.438385,275.252716
	C437.339111,277.160156 437.237671,279.108917 436.731018,281.454010
	C435.914795,281.862518 435.503815,281.874664 435.018616,281.439148
	C434.944336,276.477325 434.944336,271.963196 434.944336,267.266449
	C432.267426,267.764740 430.441101,268.104706 428.704529,268.427979
	C428.454010,273.172546 428.221405,277.578217 427.694916,281.918701
	C427.002167,281.823578 426.603302,281.793640 426.204407,281.763702
z"/> */}
      <path fill="#4597C0" opacity="1.000000" stroke="none"
        d="
M673.021851,133.885422
	C669.587830,140.897400 666.153809,147.909363 662.466187,155.174377
	C661.997559,155.334457 661.782593,155.241501 661.289368,154.932983
	C658.677795,151.096176 658.921265,147.819412 662.150208,144.786163
	C662.534485,144.425201 662.252075,143.354507 662.425049,142.114227
	C664.197205,138.086151 665.823059,134.556671 667.831299,131.041153
	C669.816406,131.998550 671.419128,132.941986 673.021851,133.885422
z"/>
      {/* <path fill="white" opacity="1.000000" stroke="none"
        d="
M479.989624,282.014252
	C479.989624,276.731842 479.989624,271.449402 479.989624,266.166992
	C480.369354,265.893158 480.749084,265.619354 481.128815,265.345520
	C483.184265,267.948273 485.239685,270.550995 487.319977,273.185181
	C489.333282,270.555481 491.336334,267.939270 493.339355,265.323029
	C493.850494,265.582306 494.361603,265.841553 494.872742,266.100830
	C494.872742,271.011841 494.872742,275.922821 494.520813,281.297485
	C493.621307,281.723663 493.073669,281.686188 492.419006,281.230835
	C492.311981,277.765564 492.311981,274.718109 492.311981,270.438812
	C490.247009,273.483856 488.942017,275.408203 487.298401,277.831909
	C485.458374,275.232239 484.106415,273.322174 481.872498,270.166046
	C481.872498,275.048187 481.872498,278.450836 481.557190,281.859741
	C480.824493,281.915405 480.407043,281.964844 479.989624,282.014252
z"/> */}
      {/* <path fill="white" opacity="1.000000" stroke="none"
        d="
M458.436218,281.742981
	C458.388519,282.129425 458.465546,282.076447 458.032013,281.855896
	C455.063690,281.426331 452.528870,281.217346 449.994080,281.008362
	C444.960052,274.979645 446.372101,267.003967 452.736816,265.862701
	C456.243927,265.233795 459.400452,265.886871 461.295715,269.379181
	C463.369293,273.199982 462.276672,277.841187 458.436218,281.742981
M459.651642,274.358093
	C459.558685,270.920441 458.698059,267.990967 454.519440,267.936066
	C451.196442,267.892365 449.905365,270.122772 449.722412,273.071320
	C449.540253,276.006866 449.905212,278.902283 453.384583,279.738342
	C457.114990,280.634674 458.889709,278.508362 459.651642,274.358093
z"/> */}
      {/* <path fill="#363636" opacity="1.000000" stroke="none"
        d="
M344.865723,282.242432
	C346.437286,277.137634 347.665222,271.888245 349.726532,266.989471
	C350.743347,264.572906 352.616760,265.571686 353.411804,267.867218
	C354.975891,272.383118 356.544830,276.897308 357.731140,281.700684
	C356.910187,281.979431 356.469879,281.969635 355.866730,281.609497
	C355.004425,278.969910 354.065033,277.495636 351.065094,277.543243
	C347.835388,277.594421 347.549042,279.749268 346.391602,281.798248
	C345.671326,281.968353 345.268524,282.105408 344.865723,282.242432
z"/> */}
      {/* <path fill="white" opacity="1.000000" stroke="none"
        d="
M256.152802,281.810181
	C256.152802,276.673553 256.152802,271.536926 256.152802,266.400299
	C256.552826,266.093079 256.952850,265.785858 257.352844,265.478638
	C259.378784,267.984344 261.404694,270.490051 263.662231,273.282227
	C265.506927,270.727234 267.441254,268.048065 269.375610,265.368927
	C269.908508,265.590393 270.441437,265.811890 270.974365,266.033356
	C270.974365,271.061737 270.974365,276.090088 270.609314,281.454590
	C269.840820,281.843933 269.437317,281.897064 268.919556,281.514343
	C268.758179,278.087982 268.711090,275.097473 268.785004,271.805267
	C268.509369,271.569366 268.112732,271.635193 267.448486,271.919250
	C266.107544,273.844818 265.034241,275.552124 263.610321,277.817200
	C261.763855,275.254883 260.382538,273.338074 258.751831,271.215973
	C258.441559,272.024872 258.380646,273.039093 258.296234,274.491760
	C258.166290,277.265350 258.059845,279.600433 257.653931,281.901733
	C256.953918,281.848694 256.553375,281.829407 256.152802,281.810181
z"/> */}
      {/* <path fill="white" opacity="1.000000" stroke="none"
        d="
M273.200195,281.789215
	C274.808563,277.275116 276.353210,272.736420 278.077576,268.267059
	C278.435211,267.340088 279.460052,266.670502 280.177368,265.882263
	C280.986084,266.783661 282.129333,267.553528 282.544434,268.609650
	C284.174042,272.755615 285.574188,276.991821 286.694641,281.572327
	C285.894714,281.954498 285.459686,281.958862 284.851166,281.617767
	C283.925598,279.022980 283.027069,277.439575 280.002197,277.478210
	C276.762604,277.519623 276.432220,279.630554 275.358826,281.744995
	C274.432037,281.776001 273.816132,281.782593 273.200195,281.789215
z"/> */}
      {/* <path fill="#2F2F2F" opacity="1.000000" stroke="none"
        d="
M409.501343,281.989349
	C409.501343,281.989349 409.182037,281.945343 409.182037,281.945343
	C409.182037,281.945343 408.859741,281.945770 408.500275,281.673401
	C408.085388,280.929169 408.029968,280.457367 407.974548,279.985535
	C409.542145,275.979553 411.065643,271.955292 412.714325,267.982941
	C413.046112,267.183502 414.054474,265.912598 414.401886,266.017273
	C415.330597,266.297119 416.488007,267.045380 416.814148,267.892548
	C418.537903,272.370117 420.033417,276.935577 421.057800,281.743347
	C420.093109,281.928558 419.678680,281.841003 419.138245,281.380341
	C417.689453,279.900696 416.534271,278.341766 415.010681,277.777496
	C411.299438,276.402985 411.218201,280.387115 409.501343,281.989349
z"/> */}
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M700.052185,173.423203
	C703.198669,173.726974 706.401489,174.769119 709.645386,174.917908
	C713.152039,175.078751 716.696960,174.405182 720.642822,174.077698
	C721.060425,174.059845 721.128845,174.128403 721.085815,174.569733
	C721.024963,176.509766 721.007080,178.008484 720.989258,179.507202
	C718.373047,181.452103 715.756836,183.397003 713.584290,185.012115
	C710.791016,182.972321 708.203369,181.082733 705.303345,179.020142
	C703.369568,177.154144 701.748108,175.461151 700.052185,173.423203
z"/>
      {/* <path fill="white" opacity="1.000000" stroke="none"
        d="
M315.438904,283.016937
	C315.438904,283.016937 315.478485,283.060516 315.808105,282.666931
	C315.776886,281.412262 315.105896,280.550507 315.107910,279.690308
	C315.117554,275.597107 312.921417,274.751434 309.204498,275.430450
	C309.067474,277.624176 308.937439,279.705719 308.503662,281.779572
	C307.801880,281.845123 307.403809,281.918365 307.005768,281.991577
	C307.005768,276.740143 307.005768,271.488739 307.005768,265.974182
	C309.289520,265.974182 311.790710,265.414673 313.821960,266.151184
	C315.447144,266.740479 317.833557,269.920074 317.607025,270.217590
	C314.581268,274.191040 318.439819,277.604401 317.672058,281.561096
	C316.583282,282.259796 316.011108,282.638367 315.438904,283.016937
M313.082367,268.127808
	C311.827606,268.127808 310.572815,268.127808 309.188049,268.127808
	C309.188049,269.907654 309.188049,271.322784 309.188049,273.615387
	C311.315643,272.914978 313.097748,272.491302 314.655884,271.651855
	C314.909851,271.515045 314.173950,269.540863 313.082367,268.127808
z"/> */}
      {/* <path fill="white" opacity="1.000000" stroke="none"
        d="
M383.417023,281.631531
	C383.417023,276.519653 383.417023,271.407776 383.417023,266.315033
	C391.028229,265.183411 394.301056,266.307556 394.456299,270.331177
	C394.675354,276.007050 390.276154,275.733734 386.159241,276.098053
	C386.064850,277.692047 385.969666,279.298584 385.520203,281.335022
	C384.582916,281.720428 383.999969,281.675995 383.417023,281.631531
M386.060760,272.834656
	C387.807220,272.700439 389.584839,272.696686 391.267273,272.294586
	C391.526428,272.232574 391.725861,269.647980 391.303894,269.417358
	C389.783600,268.586334 387.985596,268.263306 385.923035,267.636047
	C385.923035,269.742554 385.923035,270.880463 386.060760,272.834656
z"/> */}
      <path fill="#C1AB80" opacity="1.000000" stroke="none"
        d="
M59.990589,68.956436
	C60.771332,68.907494 61.552074,68.858551 62.685799,68.874329
	C63.038784,68.939064 62.940578,69.313980 62.893425,69.633965
	C60.004135,71.330872 57.163105,72.710091 54.319576,74.084145
	C51.044903,75.666527 47.676804,77.082069 44.512680,78.860748
	C39.286785,81.798454 34.191933,84.969269 28.927418,87.927353
	C28.812981,87.812851 28.584135,87.583817 28.721016,87.308716
	C29.595179,86.042702 30.332464,85.051788 31.069748,84.060867
	C31.069748,84.060867 30.989660,84.025757 31.346867,84.013657
	C32.796768,83.000900 33.889465,82.000244 34.982166,80.999580
	C34.982166,80.999580 35.001488,81.003487 35.354935,80.968346
	C38.812374,78.969704 41.916367,77.006203 45.020359,75.042702
	C46.150536,74.464516 47.280712,73.886337 49.068176,73.199387
	C50.636929,72.476250 51.548393,71.861885 52.459862,71.247528
	C53.095539,71.191513 53.731213,71.135506 55.028717,71.031082
	C57.123890,70.307259 58.557240,69.631851 59.990589,68.956436
z"/>
      {/* <path fill="white" opacity="1.000000" stroke="none"
        d="
M465.037598,282.049469
	C465.080353,276.831329 465.080353,271.589478 465.080353,265.959808
	C467.555420,265.959808 470.059387,265.352570 471.991547,266.143036
	C473.677399,266.832764 476.145172,270.011475 475.818512,270.521271
	C473.302612,274.447784 476.329163,277.568481 476.476990,281.358002
	C475.601135,281.700104 475.005920,281.683899 474.299164,281.310913
	C473.476257,277.402618 472.591766,274.064362 467.535675,275.587708
	C467.344177,277.762146 467.159210,279.862152 466.652283,281.911560
	C465.898132,281.885986 465.466003,281.911072 465.033844,281.936127
	C465.033844,281.936127 464.994873,282.025757 465.037598,282.049469
M473.516510,269.756653
	C471.628113,269.015991 469.739746,268.275360 467.439087,267.372986
	C467.439087,269.995972 467.439087,271.412170 467.439087,274.569275
	C470.159210,272.814911 471.933228,271.670746 473.516510,269.756653
z"/> */}
      <path fill="white" opacity="1.000000" stroke="none"
        d="
M392.406982,171.305634
	C389.331451,172.029465 385.969788,173.686371 384.932404,169.386490
	C384.546326,167.786163 385.175171,164.841599 386.279724,164.243683
	C387.860687,163.387848 391.520599,163.378128 392.110321,164.342178
	C393.164398,166.065338 392.588867,168.785339 392.406982,171.305634
z"/>
      <path fill="#C1AB80" opacity="1.000000" stroke="none"
        d="
M72.571030,66.810791
	C78.226860,66.717155 83.492470,66.717155 88.758072,66.717155
	C88.873634,67.094032 88.989197,67.470901 89.104759,67.847778
	C84.700058,69.614311 80.295364,71.380844 75.356415,72.896774
	C74.937279,71.606598 75.052399,70.567024 75.226707,68.992996
	C71.893234,68.992996 68.444138,68.992996 65.196121,68.723274
	C66.590752,67.948296 67.784309,67.443031 68.977867,66.937775
	C70.045509,66.926659 71.113159,66.915543 72.571030,66.810791
z"/>
      {/* <path fill="white" opacity="1.000000" stroke="none"
        d="
M289.106384,281.866058
	C289.106384,276.758362 289.106384,271.650665 289.106384,266.276703
	C292.365967,266.276703 295.621399,266.276703 298.876862,266.276703
	C298.925140,266.692810 298.973450,267.108917 299.021759,267.525024
	C296.631348,267.796051 294.240906,268.067078 291.861389,268.336853
	C291.351349,271.760162 291.351349,271.760162 298.247314,274.279755
	C296.066956,274.571472 293.886566,274.863190 291.452942,275.188812
	C291.353760,277.187561 291.257141,279.135223 290.752991,281.465149
	C289.932434,281.853607 289.519409,281.859833 289.106384,281.866058
z"/> */}
      <path fill="#C1AB80" opacity="1.000000" stroke="none"
        d="
M18.039358,98.031822
	C18.742317,97.045563 19.445276,96.059303 20.506557,94.625824
	C22.301067,92.505585 23.737253,90.832565 25.173441,89.159538
	C25.173441,89.159538 25.000423,89.013809 25.394165,89.043991
	C26.719982,88.577385 27.652058,88.080605 28.584135,87.583817
	C28.584135,87.583817 28.812981,87.812851 28.875183,88.266663
	C23.582327,96.428482 16.245920,102.842041 13.484488,112.278656
	C13.431855,112.458519 11.892137,112.203217 11.132490,111.801979
	C11.821497,109.641350 12.424258,107.829704 13.027021,106.018051
	C13.510566,105.118126 13.994109,104.218193 15.016887,103.006371
	C16.383867,101.140259 17.211613,99.586037 18.039358,98.031822
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M662.134766,156.163910
	C664.394470,156.639328 666.600098,157.505890 669.204834,158.291779
	C669.603943,158.211136 669.686279,158.189331 669.671265,158.435684
	C669.656250,158.682037 670.003723,159.032684 670.197632,159.323242
	C676.215820,162.244598 682.040039,164.875366 687.864258,167.506165
	C687.990173,167.765869 688.192444,167.933548 688.825012,168.315094
	C690.133545,169.407745 691.088135,170.194489 692.042786,170.981232
	C686.189758,168.633820 680.305664,166.360214 674.495239,163.911789
	C670.910767,162.401367 667.398804,160.701157 663.945435,158.910370
	C663.134705,158.489990 662.692444,157.359070 662.134766,156.163910
z"/>
      {/* <path fill="#2F2F2F" opacity="1.000000" stroke="none"
        d="
M397.208801,281.779938
	C397.208801,276.569000 397.208801,271.358093 397.208801,266.147156
	C397.781891,266.085205 398.354980,266.023254 398.928040,265.961304
	C399.213898,267.998169 399.629883,270.027283 399.751831,272.073914
	C399.895813,274.491455 399.785645,276.924164 399.785645,279.783203
	C402.247833,279.783203 404.200531,279.783203 406.461548,280.315002
	C403.582855,281.157837 400.395813,281.468872 397.208801,281.779938
z"/> */}
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M741.114746,117.076263
	C741.529602,117.064301 741.944397,117.052338 742.670044,117.043945
	C742.642822,122.709274 742.958618,128.515961 741.746704,133.984024
	C740.876465,137.910019 737.964783,141.383530 735.541992,145.082901
	C735.120117,145.106903 735.018555,145.013397 735.108276,144.761322
	C735.319763,144.001282 735.441406,143.493301 735.754883,142.689041
	C736.316467,141.296875 736.686218,140.200989 737.301025,138.882904
	C738.019958,137.437988 738.493958,136.215271 739.235046,134.774689
	C740.838867,131.976288 741.849121,129.458359 738.212219,127.831825
	C738.283508,127.232208 738.354736,126.632591 738.672058,125.716141
	C739.650330,122.624954 740.382507,119.850609 741.114746,117.076263
z"/>
      <path fill="#E9DEC8" opacity="1.000000" stroke="none"
        d="
M12.673742,106.061371
	C12.424258,107.829704 11.821497,109.641350 10.886686,112.001694
	C10.365356,113.367554 10.176074,114.184708 9.715754,115.232986
	C8.378843,119.005852 7.312973,122.547600 6.174874,126.446838
	C6.054696,127.531380 6.006744,128.258438 5.958791,128.985489
	C5.315191,130.978088 4.671593,132.970673 3.725978,135.140594
	C3.293849,124.637436 6.750955,115.049408 12.673742,106.061371
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M725.392334,167.953949
	C725.348328,166.892944 725.641724,165.777039 726.194702,164.094818
	C726.980042,162.038559 727.505798,160.548645 728.292236,158.901840
	C728.734497,158.176514 728.916138,157.608063 729.350281,156.801010
	C731.408020,152.712738 733.213318,148.863068 735.018555,145.013397
	C735.018555,145.013397 735.120117,145.106903 735.176514,145.149475
	C733.622803,153.412933 731.804871,161.546844 725.392334,167.953949
z"/>
      {/* <path fill="white" opacity="1.000000" stroke="none"
        d="
M367.040771,281.942902
	C367.040771,276.627380 367.040771,271.311859 367.040771,265.996338
	C367.509552,265.963257 367.978302,265.930176 368.447083,265.897095
	C368.447083,270.328583 368.447083,274.760071 368.447083,278.833984
	C371.655396,279.787659 373.924286,280.462097 375.618134,281.513062
	C372.375641,281.907318 369.708191,281.925110 367.040771,281.942902
z"/> */}
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M157.074829,231.552399
	C164.992813,231.100296 173.005356,231.003815 181.481598,230.917633
	C181.692322,233.930511 179.952637,233.970505 177.425751,233.675461
	C172.018295,233.044083 166.559311,232.860291 161.124527,232.451950
	C159.799988,232.352448 158.487427,232.093613 157.074829,231.552399
z"/>
      {/* <path fill="white" opacity="1.000000" stroke="none"
        d="
M360.173279,281.786407
	C360.173279,276.523773 360.173279,271.261169 360.173279,265.998535
	C360.845306,265.991241 361.517365,265.983917 362.189392,265.976624
	C362.189392,271.012329 362.189392,276.048065 361.768005,281.469147
	C360.955536,281.831818 360.564392,281.809113 360.173279,281.786407
z"/> */}
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M44.786583,74.759460
	C41.916367,77.006203 38.812374,78.969704 35.354630,80.958557
	C37.006451,77.085030 38.923985,73.056931 44.786583,74.759460
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M721.026306,174.025421
	C721.269226,173.503265 721.546265,173.015564 721.884033,172.253006
	C722.696533,171.273056 723.448364,170.567978 724.479492,169.722488
	C725.845459,172.367905 726.932068,175.153732 728.016418,178.307968
	C727.254028,178.692459 726.493835,178.708527 725.344788,178.293686
	C723.680176,176.617981 722.404480,175.373199 721.128845,174.128418
	C721.128845,174.128403 721.060425,174.059845 721.026306,174.025421
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M6.063924,231.623352
	C14.325171,231.192078 22.690649,231.101318 31.523193,231.029938
	C28.966885,231.370575 25.948503,231.894455 22.919048,231.969147
	C17.338852,232.106689 11.752148,231.980255 6.063924,231.623352
z"/>
      <path fill="#C1AB80" opacity="1.000000" stroke="none"
        d="
M70.440529,75.426163
	C68.682671,77.057884 66.924812,78.689606 64.997330,80.610870
	C64.455811,80.965645 64.083923,81.030869 63.344620,81.036362
	C62.977211,80.976631 62.807552,80.793892 62.937962,80.476425
	C64.938416,77.666481 66.419472,74.568077 70.440529,75.426163
z"/>
      <path fill="#53C1E3" opacity="1.000000" stroke="none"
        d="
M631.401672,141.172302
	C634.689941,140.500992 637.564087,141.497894 639.794861,144.749222
	C637.181763,143.847519 634.379578,142.649994 631.401672,141.172302
z"/>
      <path fill="#C1AB80" opacity="1.000000" stroke="none"
        d="
M56.670216,87.832932
	C56.390064,87.900253 56.166252,88.051140 55.610069,88.588745
	C54.151989,89.604385 53.082619,90.316895 51.999573,90.657730
	C53.932083,88.463196 55.878265,86.640343 57.910084,84.906921
	C57.995724,84.996361 58.166107,85.176086 58.021381,85.446350
	C57.474510,86.422058 57.072365,87.127495 56.670216,87.832932
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M46.050262,100.146622
	C44.627010,103.072601 43.203754,105.998573 41.454559,109.027969
	C41.128616,109.131393 41.041233,109.045776 41.030083,108.654190
	C41.711494,106.527008 42.404057,104.791412 43.307816,102.936386
	C43.774700,102.596375 43.933376,102.320084 44.254257,101.865524
	C45.025742,101.210861 45.538002,100.678741 46.050262,100.146622
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M28.721016,87.308716
	C27.652058,88.080605 26.719982,88.577385 25.474842,89.123482
	C26.882357,87.453690 28.602932,85.734596 30.696629,84.038185
	C30.332464,85.051788 29.595179,86.042702 28.721016,87.308716
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M24.796928,89.138611
	C23.737253,90.832565 22.301067,92.505585 20.552980,94.318031
	C19.420158,90.944641 22.136929,90.200722 24.796928,89.138611
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M51.113808,94.118141
	C50.790245,96.269196 51.843502,99.348557 47.413010,98.673752
	C47.024857,97.904495 47.042942,97.465927 47.271317,96.915482
	C47.757420,96.616661 47.938587,96.362289 48.308418,95.935493
	C49.355721,95.188934 50.119705,94.547386 50.942169,93.957886
	C51.000645,94.009941 51.113808,94.118141 51.113808,94.118141
z"/>
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M397.068848,282.008057
	C400.395813,281.468872 403.582855,281.157837 406.836121,280.457886
	C407.082886,280.078766 407.263428,280.088593 407.709259,280.041992
	C408.029968,280.457367 408.085388,280.929169 408.340698,281.695923
	C404.961823,282.319611 401.382996,282.648438 397.347107,282.873657
	C396.902954,282.592041 396.915955,282.414093 397.068848,282.008057
z"/> */}
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M57.058350,87.863426
	C57.072365,87.127495 57.474510,86.422058 58.325825,85.361160
	C59.853367,84.344620 60.931740,83.683548 62.010113,83.022469
	C62.294189,86.337502 60.059097,87.292542 57.058350,87.863426
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M52.013248,91.029396
	C53.082619,90.316895 54.151989,89.604385 55.524040,88.775803
	C54.478062,90.427406 53.129398,92.195076 51.447273,94.040443
	C51.113808,94.118141 51.000645,94.009941 50.981598,93.646347
	C50.994644,92.865410 51.026737,92.448074 51.272324,91.921654
	C51.752014,91.612381 51.927826,91.351326 52.013248,91.029396
z"/>
      <path fill="#E8A22E" opacity="1.000000" stroke="none"
        d="
M692.282715,171.020996
	C691.088135,170.194489 690.133545,169.407745 689.025391,168.340179
	C691.115784,168.872665 693.359680,169.685944 695.021851,170.777618
	C693.951111,171.118607 693.462158,171.181183 692.973267,171.243744
	C692.973267,171.243759 692.522644,171.060760 692.282715,171.020996
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M68.754181,66.679306
	C67.784309,67.443031 66.590752,67.948296 64.847397,68.729958
	C63.845253,69.108902 63.392918,69.211441 62.940578,69.313980
	C62.940578,69.313980 63.038784,68.939064 63.056374,68.744476
	C64.892807,67.840202 66.711655,67.130524 68.754181,66.679306
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M59.765503,68.693146
	C58.557240,69.631851 57.123890,70.307259 55.334690,70.937103
	C55.445606,68.118324 57.096043,67.538490 59.765503,68.693146
z"/>
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M449.951660,281.266907
	C452.528870,281.217346 455.063690,281.426331 458.020325,281.810669
	C455.558533,282.322205 452.674927,282.658447 449.350220,282.859558
	C449.242462,282.324768 449.575836,281.925110 449.951660,281.266907
z"/> */}
      <path fill="#C1AB80" opacity="1.000000" stroke="none"
        d="
M62.121033,82.771812
	C60.931740,83.683548 59.853367,84.344620 58.470551,85.090897
	C58.166107,85.176086 57.995724,84.996361 58.010788,84.582993
	C59.619755,83.044373 61.213654,81.919128 62.807549,80.793892
	C62.807552,80.793892 62.977211,80.976631 63.062382,81.068741
	C62.842354,81.614288 62.537151,82.067719 62.121033,82.771812
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M680.450500,171.976440
	C681.582886,171.791183 682.652283,171.949188 683.721619,172.107193
	C683.620728,172.544647 683.519836,172.982101 683.419006,173.419571
	C682.408508,173.052948 681.397949,172.686340 680.450500,171.976440
z"/>
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M366.907104,282.114685
	C369.708191,281.925110 372.375641,281.907318 375.484894,281.938324
	C376.230469,282.084381 376.534180,282.181610 376.963409,282.505493
	C373.981537,282.809692 370.874207,282.887207 367.315002,282.838531
	C366.863190,282.712341 366.773407,282.286438 366.907104,282.114685
z"/> */}
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M321.137573,281.953857
	C324.268280,281.810425 327.250427,281.914246 330.762268,282.220612
	C331.291962,282.423126 331.151093,282.650269 331.151093,282.650269
	C328.034729,282.769501 324.918365,282.888702 321.348083,282.889099
	C320.925781,282.580536 320.957397,282.390839 321.137573,281.953857
z"/> */}
      <path fill="#E9DEC8" opacity="1.000000" stroke="none"
        d="
M17.690594,98.071274
	C17.211613,99.586037 16.383867,101.140259 15.232461,102.789566
	C15.719811,101.293343 16.530821,99.702026 17.690594,98.071274
z"/>
      <path fill="#C1AB80" opacity="1.000000" stroke="none"
        d="
M47.061028,97.027359
	C47.042942,97.465927 47.024857,97.904495 47.013466,98.672531
	C46.753914,99.217857 46.487663,99.433701 46.135838,99.898079
	C45.538002,100.678741 45.025742,101.210861 44.238316,101.483734
	C44.995777,99.825439 46.028404,98.426399 47.061028,97.027359
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M34.616730,80.995316
	C33.889465,82.000244 32.796768,83.000900 31.381119,84.041496
	C32.122543,83.051300 33.186920,82.021179 34.616730,80.995316
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M52.063301,71.174805
	C51.548393,71.861885 50.636929,72.476250 49.370216,73.085800
	C49.898891,72.421356 50.782818,71.761719 52.063301,71.174805
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M693.028198,171.531189
	C693.462158,171.181183 693.951111,171.118607 694.809326,171.010956
	C695.178650,170.965897 695.171082,171.363480 695.144470,171.560196
	C694.439575,171.777481 693.761353,171.798050 693.028198,171.531189
z"/>
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M337.396210,281.718475
	C337.961792,281.727142 338.527405,281.735840 339.380676,281.710510
	C339.782623,281.837006 339.896851,281.997528 340.064362,282.448730
	C339.306641,282.826324 338.495605,282.913269 337.365692,282.596436
	C337.163300,282.034546 337.279755,281.876495 337.396210,281.718475
z"/> */}
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M360.044708,282.007141
	C360.564392,281.809113 360.955536,281.831818 361.633667,281.919617
	C362.223297,282.097595 362.525909,282.210510 362.954346,282.546570
	C362.273834,282.839661 361.467468,282.909576 360.270569,282.858521
	C359.892059,282.567627 359.904083,282.397766 360.044708,282.007141
z"/> */}
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M273.036743,281.969696
	C273.816132,281.782593 274.432037,281.776001 275.516113,281.985687
	C276.020416,282.390167 276.056549,282.578400 276.092682,282.766602
	C275.266022,282.835938 274.439331,282.905304 273.230804,282.805603
	C272.848938,282.636566 272.873260,282.150177 273.036743,281.969696
z"/> */}
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M383.215088,281.871063
	C383.999969,281.675995 384.582916,281.720428 385.464233,281.759399
	C385.873688,281.894043 385.984772,282.034180 386.114746,282.441895
	C385.312439,282.801758 384.491241,282.894043 383.274139,282.854431
	C382.923187,282.518555 382.968170,282.314575 383.215088,281.871063
z"/> */}
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M474.410675,281.667694
	C475.005920,281.683899 475.601135,281.700104 476.495483,281.735352
	C476.892365,281.902435 476.990143,282.050476 477.105591,282.464050
	C476.308868,282.809906 475.494415,282.890259 474.351776,282.549438
	C474.152618,281.974731 474.281647,281.821228 474.410675,281.667694
z"/> */}
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M492.526062,281.648682
	C493.073669,281.686188 493.621307,281.723663 494.449524,281.742554
	C494.836395,281.875000 494.942657,282.026062 495.085907,282.451660
	C494.315704,282.816833 493.508514,282.907440 492.414246,282.578247
	C492.260162,281.988495 492.393127,281.818573 492.526062,281.648682
z"/> */}
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M426.057495,281.977539
	C426.603302,281.793640 427.002167,281.823578 427.803650,282.096161
	C428.206207,282.338806 428.118958,282.745758 428.118958,282.745758
	C427.615723,282.810150 427.112488,282.874542 426.240173,282.823853
	C425.884216,282.536346 425.897400,282.363861 426.057495,281.977539
z"/> */}
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M419.264252,281.753479
	C419.678680,281.841003 420.093109,281.928558 420.811584,282.111755
	C421.115601,282.207397 421.264465,282.452576 421.201538,282.581482
	C420.644684,282.798462 420.150757,282.886597 419.330688,282.610107
	C419.091125,282.081482 419.177673,281.917480 419.264252,281.753479
z"/> */}
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M435.092865,281.886841
	C435.503815,281.874664 435.914795,281.862518 436.632690,281.883423
	C436.939667,281.916504 437.188354,282.277618 437.160522,282.495056
	C436.625824,282.798004 436.118896,282.883453 435.216858,282.610229
	C434.821686,282.251556 435.092865,281.886841 435.092865,281.886841
z"/> */}
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M479.880920,282.173035
	C480.407043,281.964844 480.824493,281.915405 481.664124,282.078156
	C482.086304,282.290344 482.093445,282.776581 482.093445,282.776581
	C481.590820,282.837128 481.088226,282.897675 480.224792,282.831909
	C479.863953,282.705597 479.772217,282.331818 479.880920,282.173035
z"/> */}
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M356.029541,281.959869
	C356.469879,281.969635 356.910187,281.979431 357.681030,282.002136
	C358.011536,282.015045 358.209045,282.333740 358.173279,282.517761
	C357.636292,282.800934 357.135010,282.900055 356.245117,282.670593
	C355.856445,282.342041 356.029541,281.959869 356.029541,281.959869
z"/> */}
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M344.791931,282.356506
	C345.268524,282.105408 345.671326,281.968353 346.550720,282.019226
	C347.052704,282.386749 347.078125,282.566437 347.103577,282.746124
	C346.599091,282.818359 346.094604,282.890625 345.225159,282.832458
	C344.860168,282.702087 344.718109,282.470551 344.791931,282.356506
z"/> */}
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M269.033844,281.950195
	C269.437317,281.897064 269.840820,281.843933 270.549408,281.802795
	C270.935059,281.962799 271.015625,282.110779 271.104248,282.511292
	C270.612854,282.832977 270.113312,282.902069 269.220764,282.644012
	C268.827728,282.316864 269.033844,281.950226 269.033844,281.950195
z"/> */}
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M315.898926,283.026672
	C316.011108,282.638367 316.583282,282.259796 317.591431,281.961334
	C318.027405,282.041443 318.276062,282.322754 318.213440,282.499695
	C317.553528,282.796570 316.956238,282.916504 315.898926,283.026672
z"/> */}
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M306.894897,282.159424
	C307.403809,281.918365 307.801880,281.845123 308.626709,282.008881
	C309.067108,282.418854 309.080688,282.591827 309.094238,282.764771
	C308.594666,282.828064 308.095093,282.891327 307.232788,282.837402
	C306.870026,282.720245 306.784058,282.327240 306.894897,282.159424
z"/> */}
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M288.959320,282.036499
	C289.519409,281.859833 289.932434,281.853607 290.651733,281.894592
	C290.958008,281.941772 291.211365,282.284332 291.175293,282.494263
	C290.620148,282.790375 290.101044,282.876526 289.216766,282.809082
	C288.851593,282.655457 288.812256,282.206909 288.959320,282.036499
z"/> */}
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M285.024628,281.963196
	C285.459686,281.958862 285.894714,281.954498 286.655884,281.963074
	C286.982025,281.975983 287.165466,282.339081 287.144104,282.541321
	C286.627625,282.823578 286.132477,282.903564 285.259949,282.671143
	C284.882538,282.358704 285.024628,281.963226 285.024628,281.963196
z"/> */}
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M256.039062,282.036316
	C256.553375,281.829407 256.953918,281.848694 257.759338,282.091583
	C258.164185,282.315216 258.109100,282.746002 258.109100,282.746033
	C257.613190,282.824402 257.117279,282.902771 256.256500,282.874390
	C255.902878,282.599213 255.914108,282.430817 256.039062,282.036316
z"/> */}
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M744.366699,114.875229
	C744.225159,114.688194 744.362793,114.434608 744.783203,114.116783
	C744.916443,114.300522 744.776367,114.552567 744.366699,114.875229
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M743.411987,115.850464
	C743.100891,115.598938 743.195984,115.334969 743.762146,115.135010
	C743.916199,115.365654 743.777893,115.578651 743.411987,115.850464
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M234.551727,174.465393
	C237.446854,174.040497 240.094498,173.751556 242.687988,174.008743
	C246.394501,174.376312 248.713440,176.493500 249.072235,180.377365
	C249.440659,184.365433 247.800919,187.336487 243.932281,188.312943
	C240.993393,189.054703 237.838486,188.940659 234.280060,189.250946
	C234.280060,183.997787 234.280060,179.421524 234.551727,174.465393
z"/>
      <path fill="white" opacity="1.000000" stroke="none"
        d="
M721.085815,174.569733
	C722.404480,175.373199 723.680176,176.617981 724.972046,178.210052
	C723.920410,178.802505 722.852539,179.047668 721.386963,179.400009
	C721.007080,178.008484 721.024963,176.509766 721.085815,174.569733
z"/>
      <path fill="#46C0E5" opacity="1.000000" stroke="none"
        d="
M667.448853,131.027191
	C665.823059,134.556671 664.197205,138.086151 662.299866,141.815323
	C661.587830,140.622650 661.147278,139.230301 660.558899,137.370636
	C659.898682,138.209793 659.023865,139.321671 658.725525,139.700821
	C655.631348,139.092743 652.584351,137.504593 650.270325,138.235886
	C644.677734,140.003265 641.637329,138.120392 639.402771,132.720734
	C640.332397,130.854126 641.567871,129.391953 642.803345,127.929794
	C642.584961,127.661270 642.366577,127.392754 642.148193,127.124229
	C639.765442,127.749893 637.382751,128.375565 635.000000,129.000610
	C635.000000,129.000000 635.000000,128.998779 635.000000,128.998779
	C636.782043,123.188217 638.402771,117.807442 643.744751,113.400360
	C647.379700,110.401512 651.193604,108.004211 654.870850,105.262505
	C657.097534,103.602341 657.325134,99.260948 658.567017,95.800430
	C660.214905,96.484062 662.783569,98.184708 665.507690,98.487640
	C667.871216,98.750504 670.410828,97.430481 673.249939,96.531242
	C674.740845,96.516792 675.854370,96.781113 677.244812,97.271286
	C679.065369,98.184120 680.609009,98.871117 682.113953,99.901886
	C680.366150,104.594925 678.657104,108.944206 676.672302,113.106812
	C675.332336,111.897987 674.268127,110.875839 672.985474,109.564255
	C667.468506,106.041718 660.860168,107.426163 656.724548,112.635719
	C652.427673,118.048386 652.816101,124.118767 657.945557,129.273804
	C659.961548,130.680450 661.139648,134.022034 664.406677,131.272766
	C665.179688,130.835434 665.650818,130.472305 666.390747,130.224976
	C667.046387,130.342148 667.433411,130.343506 667.701660,130.501404
	C667.583008,130.657928 667.448853,131.027191 667.448853,131.027191
z"/>
      <path fill="#B5975A" opacity="1.000000" stroke="none"
        d="
M682.152710,99.558113
	C680.609009,98.871117 679.065369,98.184120 677.403381,96.950394
	C679.623596,92.580421 682.631226,88.948822 680.853210,83.946480
	C680.546204,82.571266 680.239136,81.196053 679.836426,79.473961
	C679.740662,79.127083 680.063416,78.963005 680.493530,78.971245
	C681.916321,79.719666 682.909058,80.459846 683.915649,81.565918
	C683.953857,82.924255 683.978149,83.916718 683.987671,85.310287
	C682.775635,89.291489 681.578430,92.871582 680.381165,96.451675
	C680.801514,96.744255 681.221802,97.036835 681.642151,97.329422
	C683.093750,95.231171 684.545349,93.132927 686.261719,91.036713
	C686.702759,91.050316 686.878906,91.061882 687.056396,91.450783
	C686.197083,94.219040 685.336426,96.609970 684.172852,99.024353
	C683.297546,99.217918 682.725098,99.388016 682.152710,99.558113
z"/>
      <path fill="#3485BC" opacity="1.000000" stroke="none"
        d="
M680.527222,84.014816
	C682.631226,88.948822 679.623596,92.580421 677.126526,96.724548
	C675.854370,96.781113 674.740845,96.516792 673.293701,96.151192
	C672.616821,95.076210 671.684326,93.619659 672.023682,93.205566
	C674.609680,90.050171 677.444214,87.098366 680.527222,84.014816
z"/>
      <path fill="#46C0E5" opacity="1.000000" stroke="none"
        d="
M636.995117,134.993286
	C637.205261,136.076309 637.415405,137.159317 637.625549,138.242340
	C637.306152,138.524292 636.986755,138.806244 636.667419,139.088211
	C633.679810,136.416992 630.692139,133.745773 627.353516,131.037582
	C627.417786,129.840027 627.844238,128.683258 628.245544,127.517853
	C628.697510,126.205345 629.103638,124.875404 629.635376,123.597008
	C629.661499,123.534218 631.201843,123.983452 631.191467,124.040504
	C630.955566,125.337967 630.601562,126.613937 630.111267,128.504715
	C631.525146,128.675766 632.862915,128.837601 634.600342,128.999115
	C635.000000,128.998779 635.000000,129.000000 634.964844,129.349258
	C633.640747,132.234818 631.549316,135.084198 636.995117,134.993286
z"/>
      <path fill="#B5975A" opacity="1.000000" stroke="none"
        d="
M47.271313,96.915482
	C46.028404,98.426399 44.995777,99.825439 43.979092,101.606270
	C43.933376,102.320084 43.774700,102.596375 42.929176,102.945587
	C38.183121,104.434723 39.074532,107.919281 39.004475,110.999245
	C39.004475,110.999245 39.000305,111.000305 38.644356,111.046837
	C36.904045,113.948662 35.873070,117.061745 34.032734,119.584389
	C32.303734,121.954414 32.125336,123.796532 33.883949,125.975174
	C33.828583,126.723366 33.773216,127.471565 33.548363,128.559906
	C29.644476,130.241409 28.934275,132.989212 28.951715,136.731323
	C29.088240,166.022385 28.921999,195.315094 29.125643,224.605377
	C29.156942,229.107208 27.825439,230.445160 23.482092,230.107758
	C18.849840,229.747910 14.166554,229.946503 9.508927,230.051376
	C7.002244,230.107803 5.944785,229.258652 5.950816,226.601624
	C6.016554,197.642944 5.925786,168.683655 6.093013,139.725800
	C6.112652,136.325180 9.206018,133.022858 6.240578,129.219360
	C6.006744,128.258438 6.054696,127.531380 6.502490,126.348328
	C10.918335,123.108414 10.367970,119.031181 9.986792,115.001869
	C10.176074,114.184708 10.365356,113.367554 10.800442,112.350677
	C11.892137,112.203217 13.431855,112.458519 13.484488,112.278656
	C16.245920,102.842041 23.582327,96.428482 28.989620,88.381165
	C34.191933,84.969269 39.286785,81.798454 44.512680,78.860748
	C47.676804,77.082069 51.044903,75.666527 54.319576,74.084145
	C57.163105,72.710091 60.004135,71.330872 62.893425,69.633965
	C63.392918,69.211441 63.845253,69.108902 64.646317,68.999680
	C68.444138,68.992996 71.893234,68.992996 75.226707,68.992996
	C75.052399,70.567024 74.937279,71.606598 74.981415,72.898331
	C73.787613,73.871353 72.434540,74.592224 70.761002,75.369629
	C66.419472,74.568077 64.938416,77.666481 62.937958,80.476425
	C61.213654,81.919128 59.619755,83.044373 57.925148,84.493553
	C55.878265,86.640343 53.932083,88.463196 51.999573,90.657730
	C51.927826,91.351326 51.752014,91.612381 50.883278,91.911041
	C49.528862,93.353180 48.776981,94.696838 48.025101,96.040497
	C47.938587,96.362289 47.757420,96.616661 47.271313,96.915482
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M453.554565,184.985352
	C453.554016,180.205795 453.554016,175.921158 453.554016,171.130341
	C459.643158,171.450989 465.760773,169.709442 469.980652,175.275986
	C472.865051,179.080826 472.838806,183.496170 470.555756,187.520004
	C466.798431,194.142105 460.288055,193.004623 453.555084,192.931366
	C453.555084,190.329941 453.555084,187.905090 453.554565,184.985352
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M528.157227,213.331329
	C525.950928,214.100830 524.097107,214.984253 522.195129,215.104263
	C518.892822,215.312607 516.363464,213.849625 515.599182,210.375443
	C514.794922,206.719711 516.414429,203.901062 519.814575,203.035446
	C523.700195,202.046219 527.821350,201.982208 531.923889,201.506470
	C532.557861,206.489014 533.031433,210.592239 528.157227,213.331329
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M295.675598,187.301910
	C296.950806,190.125946 297.953247,192.646835 299.187469,195.750534
	C291.553986,195.750534 284.972351,195.750534 278.380402,195.750534
	C279.224762,185.475159 286.952271,181.544601 295.675598,187.301910
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M618.033142,185.590118
	C627.762329,183.952652 632.318970,187.162247 633.210815,196.604233
	C633.558838,200.288727 633.089355,204.235901 632.098633,207.816147
	C630.748108,212.696121 626.793274,214.865112 621.829895,214.835922
	C616.851746,214.806656 613.332825,212.482361 611.615112,207.657654
	C609.080322,200.538055 610.135803,188.168228 618.033142,185.590118
z"/>
      <path fill="black" opacity="1.000000" stroke="none"
        d="
M355.958008,215.213287
	C351.721405,215.014404 349.161926,213.293991 348.968384,209.221069
	C348.759674,204.828400 351.718994,202.918259 355.412201,202.295670
	C358.645630,201.750626 361.995361,201.895660 365.187012,201.741028
	C367.905090,209.844681 363.441864,213.931686 355.958008,215.213287
z"/>
      <path fill="#ECAD4C" opacity="1.000000" stroke="none"
        d="
M683.901794,81.200035
	C682.909058,80.459846 681.916321,79.719666 680.644043,78.870758
	C679.566284,77.113258 678.768005,75.464485 677.901489,73.475708
	C682.822510,70.176079 682.872864,69.656021 678.543701,65.802246
	C678.686096,65.328682 678.828491,64.855118 678.970947,64.381554
	C682.124023,65.328003 685.277100,66.274452 689.021729,67.398468
	C688.550476,66.225021 687.875916,65.183823 687.768738,64.087135
	C687.673950,63.117958 688.007080,61.951691 688.547974,61.135166
	C688.860535,60.663288 690.447144,60.356998 690.615051,60.588749
	C691.237854,61.448051 691.897705,62.584450 691.839844,63.575642
	C691.670715,66.469162 691.162415,69.342873 690.711731,72.803299
	C694.116272,70.820969 695.617615,64.188805 693.967041,60.998478
	C692.213684,57.609558 692.194824,54.165291 695.541443,52.319595
	C697.245117,51.380051 700.154724,52.627167 702.519165,52.885830
	C702.728821,53.412872 702.938416,53.939911 703.148010,54.466949
	C701.507446,55.804333 699.866821,57.141720 697.856873,58.780224
	C698.085632,59.666500 698.601624,61.665646 699.210999,64.089409
	C699.304321,64.514023 699.306702,64.786469 698.854004,64.943375
	C697.083557,66.983635 694.628235,68.807121 698.080200,70.919556
	C698.066467,70.896973 698.118835,70.904129 698.075562,71.280212
	C697.595886,73.194328 697.159424,74.732361 696.891907,75.675133
	C697.997009,77.788055 700.220154,80.322556 699.674561,81.281197
	C696.708801,86.491974 691.873169,83.915215 687.458862,82.903374
	C687.000122,81.959122 686.332336,80.584694 685.664612,79.210266
	C685.077026,79.873520 684.489380,80.536781 683.901794,81.200035
z"/>
      <path fill="#AF60E9" opacity="1.000000" stroke="none"
        d="
M741.985352,81.991585
	C741.330811,83.424965 740.676331,84.858337 739.694397,86.805801
	C738.582092,89.553001 737.797119,91.786110 737.005371,94.395897
	C734.000183,101.612648 731.001831,108.452721 727.721802,115.256035
	C727.254028,115.186165 727.067871,115.153046 726.839478,114.750320
	C722.430664,112.603119 718.064026,110.825523 713.422119,108.935852
	C713.591919,112.798813 713.726440,115.860367 713.530457,118.994583
	C710.378784,122.295570 707.755005,126.110733 702.918518,121.609978
	C702.486511,121.207916 700.903320,121.775093 700.001831,122.202400
	C698.266968,123.024734 696.637512,124.069321 694.611572,124.976532
	C689.887085,123.003380 690.477173,118.534912 689.164429,114.690918
	C689.221741,113.910988 689.303040,113.468544 689.703735,112.975876
	C691.688599,110.954430 693.354065,108.983208 695.256714,106.998756
	C695.624329,106.637253 695.754639,106.288986 696.052246,105.702255
	C696.791382,104.978294 697.363220,104.492798 698.316284,103.997009
	C700.699341,101.411392 704.278503,98.863220 704.323425,96.254219
	C704.386597,92.585518 705.937439,92.529068 708.374634,91.587830
	C713.115906,89.756691 716.187988,84.170860 714.843750,80.508942
	C714.915833,79.821335 715.000549,79.432846 715.419556,78.965462
	C715.555115,77.584694 715.356567,76.282822 715.073303,74.665291
	C714.951233,73.916176 714.913940,73.482719 714.876587,73.049263
	C722.085571,70.786087 726.847290,63.413872 735.295776,62.785606
	C735.761414,64.997040 736.119873,66.699593 736.723572,69.566841
	C738.524719,67.238823 739.791016,65.602119 741.235046,63.735645
	C737.990906,61.692551 735.182190,59.923691 732.105957,57.986324
	C738.550903,56.230320 743.286743,58.508850 745.964111,64.639328
	C746.000000,65.000534 745.994751,65.005821 745.593872,65.005203
	C744.155457,65.542076 742.515625,65.838722 742.187317,66.659798
	C740.927917,69.809326 739.847229,73.078285 739.177002,76.398987
	C738.714050,78.693207 738.263306,81.543594 741.985352,81.991585
M725.691345,80.155472
	C726.368103,78.670074 727.044861,77.184677 727.721680,75.699303
	C726.448730,75.135460 725.116943,74.016335 723.917236,74.143456
	C722.291260,74.315765 719.605652,75.205658 719.401672,76.202507
	C718.573486,80.249870 718.520630,84.455872 718.181824,88.603371
	C718.733093,88.871208 719.284302,89.139038 719.835571,89.406876
	C720.885071,87.885048 722.014343,86.410835 722.959717,84.826836
	C723.766052,83.475822 724.360779,81.998550 725.691345,80.155472
M708.625061,95.096458
	C709.079529,95.720322 709.841003,96.934830 709.943665,96.881531
	C712.407227,95.601151 714.800171,94.185028 717.205994,92.793526
	C716.785889,92.071365 716.365784,91.349197 715.945618,90.627029
	C713.664246,91.940620 711.382874,93.254204 708.625061,95.096458
M718.544189,104.852379
	C718.772766,104.033104 719.001343,103.213821 719.229919,102.394539
	C718.345215,102.467690 717.460449,102.540833 716.575745,102.613991
	C716.995422,103.336571 717.415100,104.059158 718.544189,104.852379
z"/>
      <path fill="#9129B3" opacity="1.000000" stroke="none"
        d="
M699.309448,67.237717
	C703.764099,67.211823 708.525513,65.842308 711.656494,70.539597
	C707.882507,71.343941 704.446777,71.742203 700.705017,72.034798
	C699.638977,71.587456 698.878906,71.245781 698.118835,70.904121
	C698.118835,70.904129 698.066467,70.896973 698.127686,70.586243
	C698.562378,69.262917 698.935913,68.250320 699.309448,67.237717
z"/>
      <path fill="#A93B64" opacity="1.000000" stroke="none"
        d="
M701.010986,72.140465
	C704.446777,71.742203 707.882507,71.343941 711.778931,70.885635
	C712.954163,71.467438 713.668762,72.109268 714.630005,72.900185
	C714.913940,73.482719 714.951233,73.916176 715.001953,75.067535
	C715.038635,76.871750 715.062012,77.958054 715.085327,79.044357
	C715.000549,79.432846 714.915833,79.821335 714.639893,80.497726
	C714.448608,80.785629 714.069885,80.628311 714.033203,80.348557
	C713.685364,79.621422 713.374329,79.174049 713.077148,78.359604
	C711.168213,71.327194 706.258484,74.424225 702.050110,74.433624
	C701.589111,73.513603 701.300049,72.827034 701.010986,72.140465
z"/>
      <path fill="#AF60E9" opacity="1.000000" stroke="none"
        d="
M748.000122,66.759995
	C747.044678,70.155487 746.034973,73.220963 744.609253,76.573059
	C744.010010,75.567917 743.470093,74.203346 743.715942,72.999222
	C744.268555,70.292503 745.210999,67.665359 745.994751,65.005829
	C745.994751,65.005821 746.000000,65.000534 746.002686,64.997528
	C746.652161,65.473015 747.299011,65.951508 748.000122,66.759995
z"/>
      <path fill="#EBB45B" opacity="1.000000" stroke="none"
        d="
M699.219238,66.870979
	C698.935913,68.250320 698.562378,69.262917 698.141357,70.608833
	C694.628235,68.807121 697.083557,66.983635 698.768311,65.049316
	C699.133301,65.500313 699.131165,66.002274 699.219238,66.870979
z"/>
      <path fill="#E89E3F" opacity="1.000000" stroke="none"
        d="
M667.820374,130.344864
	C667.433411,130.343506 667.046387,130.342148 666.111694,130.016891
	C663.705444,123.798225 665.833191,120.111732 671.662598,118.958900
	C672.919189,118.710381 674.107971,118.118744 675.726685,117.734177
	C677.737244,117.841629 679.349121,117.900070 681.016479,118.282738
	C681.791748,119.253441 682.511536,119.899910 683.731628,120.995705
	C683.862244,119.145363 683.937195,118.083313 684.363525,116.988029
	C685.838623,116.599350 686.962219,116.243912 688.107422,116.308044
	C687.784790,122.674370 690.492554,126.746887 695.909790,129.511475
	C696.666809,130.263489 697.315918,130.725708 697.937744,131.507385
	C698.185852,132.593597 698.226868,133.699265 698.771729,134.075912
	C705.954651,139.040695 719.429993,134.949753 720.919373,124.453423
	C721.465942,120.601616 722.504944,119.093376 726.258423,121.472755
	C727.032898,121.963730 728.161804,121.895798 729.127319,122.085464
	C726.510742,127.844688 723.894165,133.603912 720.674683,139.681915
	C712.923767,140.101761 705.750854,138.086258 698.586731,140.790665
	C697.218079,141.307358 694.840027,139.500122 693.065063,138.516891
	C689.503601,136.543961 686.210510,133.934250 682.453857,132.533386
	C680.718323,131.886200 678.153992,133.461456 675.965454,134.029068
	C675.526489,134.011734 675.087463,133.994385 674.320435,133.578156
	C673.097351,131.746582 672.202332,130.313919 670.761292,128.007278
	C670.823120,125.784058 672.885559,125.982277 675.523926,126.210968
	C678.172241,126.440529 680.899414,125.925896 683.556824,125.511604
	C683.733948,125.484001 683.727478,122.641335 683.614380,122.627045
	C680.032471,122.174217 676.395081,121.522194 672.840576,121.812149
	C671.468689,121.924057 669.991089,124.070915 669.087952,125.601257
	C668.286743,126.958969 668.214478,128.746872 667.820374,130.344864
z"/>
      <path fill="#EAA636" opacity="1.000000" stroke="none"
        d="
M675.971924,134.271332
	C678.153992,133.461456 680.718323,131.886200 682.453857,132.533386
	C686.210510,133.934250 689.503601,136.543961 693.065063,138.516891
	C694.840027,139.500122 697.218079,141.307358 698.586731,140.790665
	C705.750854,138.086258 712.923767,140.101761 720.522278,140.000946
	C720.236511,140.997818 719.500244,141.994461 718.068359,143.015472
	C713.345154,143.292755 716.487244,145.738434 716.127014,147.112946
	C716.101562,147.839432 716.076111,148.565903 715.684692,149.687134
	C712.930786,151.427765 710.992798,152.947342 713.033936,156.002487
	C713.019958,156.442596 713.005981,156.882706 712.681519,157.692734
	C712.303101,158.734299 712.235107,159.405945 712.167114,160.077591
	C712.167175,160.077591 712.094238,160.540558 711.652710,160.774139
	C710.503845,162.376740 709.796570,163.745743 709.089355,165.114746
	C708.320679,166.080139 707.552063,167.045547 706.108276,168.026550
	C704.967529,168.035965 704.501892,168.029755 704.036316,168.023544
	C703.105896,166.883377 702.175476,165.743210 701.366943,164.029984
	C703.167786,163.133728 704.846680,162.810532 705.832031,162.620834
	C703.796997,159.026367 701.944763,155.532104 699.879883,152.168396
	C697.674500,148.575745 695.880005,142.898361 692.820496,142.050995
	C686.787109,140.379944 681.914734,136.494553 675.990234,134.998169
	C675.990234,134.998169 675.978333,134.513611 675.971924,134.271332
M707.495117,147.923981
	C713.200745,145.033585 707.333862,143.419495 707.190735,140.868088
	C704.861084,142.036469 703.024292,142.957672 699.478333,144.736069
	C702.731323,146.103867 704.726868,146.942917 707.495117,147.923981
z"/>
      <path fill="#B581E6" opacity="1.000000" stroke="none"
        d="
M728.003479,115.292786
	C731.001831,108.452721 734.000183,101.612648 737.342102,94.338989
	C740.012634,92.097580 741.949036,91.554588 741.953186,95.538048
	C741.955200,97.495766 741.635132,99.466324 741.324951,101.409378
	C740.600037,105.951569 739.792908,110.480637 739.019043,115.015015
	C739.019043,115.015015 739.009827,115.506317 738.664185,115.803474
	C735.758606,116.486465 736.955322,122.558365 732.439941,119.984558
	C731.974548,119.642403 731.509094,119.300240 730.708191,118.854324
	C730.372681,118.750572 730.229126,118.600937 730.207153,118.310776
	C729.457947,117.111343 728.730713,116.202065 728.003479,115.292786
z"/>
      <path fill="#DA7D2A" opacity="1.000000" stroke="none"
        d="
M729.363464,121.831818
	C728.161804,121.895798 727.032898,121.963730 726.258423,121.472755
	C722.504944,119.093376 721.465942,120.601616 720.919373,124.453423
	C719.429993,134.949753 705.954651,139.040695 698.771729,134.075912
	C698.226868,133.699265 698.185852,132.593597 698.291748,131.586548
	C707.866333,134.427460 716.321289,129.599670 717.868225,119.974060
	C718.477844,116.180588 719.712891,115.527412 723.099304,116.932678
	C725.323608,117.855736 727.842285,118.069519 730.229126,118.600937
	C730.229126,118.600937 730.372681,118.750572 730.412231,118.848595
	C730.167725,119.823799 729.883667,120.700981 729.363464,121.831818
z"/>
      <path fill="#E59E50" opacity="1.000000" stroke="none"
        d="
M728.031616,159.058731
	C727.505798,160.548645 726.980042,162.038559 726.185181,163.744568
	C725.377991,161.843597 723.988281,159.515060 724.452209,157.646851
	C726.266541,150.340820 728.784241,143.212601 730.780090,135.946747
	C731.408386,133.659546 731.042786,131.114700 731.487366,128.754700
	C731.688354,127.687454 732.620972,126.157768 733.469421,125.972588
	C734.419434,125.765221 735.649780,126.842705 736.737488,127.978401
	C732.330383,134.053040 731.490173,140.489212 730.432861,147.600433
	C732.706055,145.555466 734.134583,144.270401 735.563049,142.985336
	C735.441406,143.493301 735.319763,144.001282 735.108276,144.761322
	C733.213318,148.863068 731.408020,152.712738 729.072021,156.943192
	C728.371338,157.902237 728.201477,158.480484 728.031616,159.058731
z"/>
      <path fill="#E89E3F" opacity="1.000000" stroke="none"
        d="
M735.754883,142.689056
	C734.134583,144.270401 732.706055,145.555466 730.432861,147.600433
	C731.490173,140.489212 732.330383,134.053040 736.878418,128.282425
	C737.236511,127.957359 737.433044,127.945572 737.920898,127.882797
	C741.849121,129.458359 740.838867,131.976288 738.873413,134.842285
	C737.848450,136.453506 737.452209,137.779312 737.056030,139.105103
	C736.686218,140.200989 736.316467,141.296875 735.754883,142.689056
z"/>
      <path fill="#A869DF" opacity="1.000000" stroke="none"
        d="
M732.369263,120.335526
	C736.955322,122.558365 735.758606,116.486465 738.663818,116.049179
	C739.530457,116.275909 740.051941,116.554100 740.844116,116.954277
	C740.382507,119.850609 739.650330,122.624954 738.510071,125.455940
	C736.167542,123.903885 734.233032,122.295189 732.369263,120.335526
z"/>
      <path fill="#ECAD4C" opacity="1.000000" stroke="none"
        d="
M713.297363,155.786835
	C710.992798,152.947342 712.930786,151.427765 715.672119,150.050400
	C715.203918,151.869659 714.382324,153.720413 713.297363,155.786835
z"/>
      <path fill="#ECAD4C" opacity="1.000000" stroke="none"
        d="
M716.468079,147.015594
	C716.487244,145.738434 713.345154,143.292755 717.732971,143.066589
	C717.665161,144.368301 717.237183,145.643280 716.468079,147.015594
z"/>
      <path fill="#ECAD4C" opacity="1.000000" stroke="none"
        d="
M712.394104,160.077972
	C712.235107,159.405945 712.303101,158.734299 712.667725,158.022705
	C712.983459,158.442093 713.002441,158.901443 713.047852,159.705399
	C713.074158,160.050018 712.621094,160.078354 712.394104,160.077972
z"/>
      <path fill="#53C1E3" opacity="1.000000" stroke="none"
        d="
M637.116089,134.727814
	C631.549316,135.084198 633.640747,132.234818 634.964844,129.349869
	C637.382751,128.375565 639.765442,127.749893 642.148193,127.124229
	C642.366577,127.392754 642.584961,127.661270 642.803345,127.929794
	C641.567871,129.391953 640.332397,130.854126 639.044983,132.653763
	C638.407654,133.481613 637.822327,133.971970 637.116089,134.727814
z"/>
      <path fill="#C1AB80" opacity="1.000000" stroke="none"
        d="
M34.184845,125.759018
	C32.125336,123.796532 32.303734,121.954414 34.032734,119.584389
	C35.873070,117.061745 36.904045,113.948662 38.644669,111.049133
	C37.495865,115.850876 35.990803,120.696869 34.184845,125.759018
z"/>
      <path fill="#C1AB80" opacity="1.000000" stroke="none"
        d="
M39.264137,110.873520
	C39.074532,107.919281 38.183121,104.434723 42.717979,103.065018
	C42.404057,104.791412 41.711494,106.527008 40.984550,108.613342
	C40.474716,109.558655 39.999260,110.153229 39.264137,110.873520
z"/>
      <path fill="#ECAD4C" opacity="1.000000" stroke="none"
        d="
M709.394043,164.955780
	C709.796570,163.745743 710.503845,162.376740 711.596436,161.001617
	C711.220703,162.262619 710.459717,163.529724 709.394043,164.955780
z"/>
      <path fill="#ECAD4C" opacity="1.000000" stroke="none"
        d="
M704.051514,168.311737
	C704.501892,168.029755 704.967529,168.035965 705.782349,168.084351
	C705.669800,168.439270 705.208008,168.752029 704.463501,169.115250
	C704.142639,168.977112 704.104675,168.788513 704.051514,168.311737
z"/>
      {/* <path fill="white" opacity="1.000000" stroke="none"
        d="
M337.300049,281.279419
	C337.279755,281.876495 337.163300,282.034546 336.971985,282.477448
	C335.251923,282.771484 333.606659,282.780731 331.556274,282.720093
	C331.151093,282.650269 331.291962,282.423126 331.208313,282.318909
	C330.828674,281.416595 330.610748,279.975830 330.223511,279.928772
	C328.278168,279.692505 326.288605,279.820435 324.140167,279.820435
	C324.140167,278.052734 324.140167,276.622589 324.140167,275.199249
	C326.612305,274.893036 328.868256,274.613586 331.124207,274.334106
	C331.111389,273.852386 331.098541,273.370667 331.085724,272.888916
	C328.903931,272.734772 326.722137,272.580597 324.541656,272.426514
	C323.669525,267.543823 326.972168,266.500061 337.203857,268.632507
	C337.203857,272.635956 337.203857,276.738159 337.300049,281.279419
z"/> */}
      {/* <path fill="white" opacity="1.000000" stroke="none"
        d="
M435.018616,281.439148
	C435.092865,281.886841 434.821686,282.251556 434.845215,282.477600
	C432.900330,282.723480 430.931854,282.743286 428.541199,282.754425
	C428.118958,282.745758 428.206207,282.338806 428.097473,282.161377
	C428.221405,277.578217 428.454010,273.172546 428.704529,268.427979
	C430.441101,268.104706 432.267426,267.764740 434.944336,267.266449
	C434.944336,271.963196 434.944336,276.477325 435.018616,281.439148
z"/> */}
      {/* <path fill="black" opacity="1.000000" stroke="none"
        d="
M258.556763,282.783264
	C258.109100,282.746002 258.164185,282.315216 258.058777,282.125366
	C258.059845,279.600433 258.166290,277.265350 258.523621,274.221985
	C258.850098,272.816193 258.925659,272.118744 259.001221,271.421265
	C260.382538,273.338074 261.763855,275.254883 263.610321,277.817200
	C265.034241,275.552124 266.107544,273.844818 267.653625,272.095093
	C268.305603,272.070770 268.484802,272.088898 268.664001,272.106995
	C268.711090,275.097473 268.758179,278.087982 268.919556,281.514343
	C269.033844,281.950226 268.827728,282.316864 268.857422,282.525085
	C265.592896,282.762360 262.298676,282.791473 258.556763,282.783264
z"/> */}
      {/* <path fill="black" opacity="1.000000" stroke="none"
        d="
M482.538818,282.799927
	C482.093445,282.776581 482.086304,282.290344 481.979401,282.071930
	C481.872498,278.450836 481.872498,275.048187 481.872498,270.166046
	C484.106415,273.322174 485.458374,275.232239 487.298401,277.831909
	C488.942017,275.408203 490.247009,273.483856 492.311981,270.438812
	C492.311981,274.718109 492.311981,277.765564 492.419006,281.230835
	C492.393127,281.818573 492.260162,281.988495 492.020203,282.463867
	C488.936859,282.787262 485.960541,282.805267 482.538818,282.799927
z"/> */}
      {/* <path fill="black" opacity="1.000000" stroke="none"
        d="
M474.299164,281.310913
	C474.281647,281.821228 474.152618,281.974731 473.957825,282.421814
	C471.917358,282.753204 469.942596,282.791016 467.587036,282.562805
	C467.206177,282.296753 466.974274,281.962158 466.974274,281.962158
	C467.159210,279.862152 467.344177,277.762146 467.535675,275.587708
	C472.591766,274.064362 473.476257,277.402618 474.299164,281.310913
z"/> */}
      {/* <path fill="black" opacity="1.000000" stroke="none"
        d="
M309.550842,282.795227
	C309.080688,282.591827 309.067108,282.418854 308.930450,282.016571
	C308.937439,279.705719 309.067474,277.624176 309.204498,275.430450
	C312.921417,274.751434 315.117554,275.597107 315.107910,279.690308
	C315.105896,280.550507 315.776886,281.412262 315.835388,282.655823
	C313.691132,282.967438 311.849274,282.896545 309.550842,282.795227
z"/> */}
      {/* <path fill="black" opacity="1.000000" stroke="none"
        d="
M284.851166,281.617798
	C285.024628,281.963226 284.882538,282.358704 284.894592,282.568481
	C282.262238,282.790009 279.617767,282.801758 276.533020,282.790070
	C276.056549,282.578400 276.020416,282.390167 275.826965,281.961273
	C276.432220,279.630554 276.762604,277.519623 280.002197,277.478210
	C283.027069,277.439575 283.925598,279.022980 284.851166,281.617798
z"/> */}
      {/* <path fill="black" opacity="1.000000" stroke="none"
        d="
M347.542725,282.769348
	C347.078125,282.566437 347.052704,282.386749 346.868195,281.986145
	C347.549042,279.749268 347.835388,277.594421 351.065094,277.543243
	C354.065033,277.495636 355.004425,278.969910 355.866730,281.609497
	C356.029541,281.959869 355.856445,282.342041 355.876160,282.550903
	C353.257904,282.770721 350.619873,282.781647 347.542725,282.769348
z"/> */}
      {/* <path fill="black" opacity="1.000000" stroke="none"
        d="
M419.138245,281.380310
	C419.177673,281.917480 419.091125,282.081482 418.960205,282.520142
	C415.961731,282.758820 413.007629,282.722809 409.777435,282.338074
	C411.218201,280.387115 411.299438,276.402985 415.010681,277.777496
	C416.534271,278.341766 417.689453,279.900696 419.138245,281.380310
z"/> */}
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M466.652283,281.911560
	C466.974274,281.962158 467.206177,282.296753 467.168640,282.496826
	C466.379059,282.697968 465.627014,282.699036 464.954407,282.318115
	C465.466003,281.911072 465.898132,281.885986 466.652283,281.911560
z"/> */}
      <path fill="#A869DF" opacity="1.000000" stroke="none"
        d="
M739.381592,114.949783
	C739.792908,110.480637 740.600037,105.951569 741.324951,101.409378
	C741.635132,99.466324 741.955200,97.495766 741.953186,95.538048
	C741.949036,91.554588 740.012634,92.097580 737.348877,93.962311
	C737.797119,91.786110 738.582092,89.553001 739.690796,87.156235
	C743.879822,86.970444 745.282715,88.991447 745.438782,92.738647
	C745.772034,100.739861 743.256897,107.919319 739.381592,114.949783
z"/>
      <path fill="#B469E7" opacity="1.000000" stroke="none"
        d="
M745.593872,65.005203
	C745.210999,67.665359 744.268555,70.292503 743.715942,72.999222
	C743.470093,74.203346 744.010010,75.567917 744.536987,76.938660
	C744.880676,77.017654 744.883728,77.517120 744.681396,77.868309
	C744.252502,78.399872 744.094971,78.627945 744.006348,78.903717
	C743.994324,79.094749 743.982239,79.285774 743.951904,79.763931
	C743.383179,80.538300 742.832764,81.025543 742.133911,81.752182
	C738.263306,81.543594 738.714050,78.693207 739.177002,76.398987
	C739.847229,73.078285 740.927917,69.809326 742.187317,66.659798
	C742.515625,65.838722 744.155457,65.542076 745.593872,65.005203
z"/>
      <path fill="#E8A22E" opacity="1.000000" stroke="none"
        d="
M675.990234,135.422897
	C681.914734,136.494553 686.787109,140.379944 692.820496,142.050995
	C695.880005,142.898361 697.674500,148.575745 699.879883,152.168396
	C701.944763,155.532104 703.796997,159.026367 705.832031,162.620834
	C704.846680,162.810532 703.167786,163.133728 701.237549,163.734070
	C698.033508,163.552475 695.977173,162.669174 695.621948,158.920059
	C695.423401,156.823975 693.140564,154.925385 691.381592,152.323395
	C687.517761,155.823181 684.214478,158.815216 680.796143,161.911530
	C682.950439,163.436646 685.323853,165.116837 687.780762,167.151581
	C682.040039,164.875366 676.215820,162.244598 670.358704,159.202866
	C670.112610,158.591064 669.899414,158.390198 669.686279,158.189331
	C669.686279,158.189331 669.603943,158.211136 669.560974,158.208633
	C670.012817,157.775940 670.825562,157.424454 670.954529,156.903687
	C672.688782,149.898788 674.327637,142.870270 675.990234,135.422897
z"/>
      <path fill="#AF60E9" opacity="1.000000" stroke="none"
        d="
M744.209229,78.823593
	C744.094971,78.627945 744.252502,78.399872 744.660645,78.117180
	C744.814453,78.325989 744.671082,78.568855 744.209229,78.823593
z"/>
      <path fill="#E59E50" opacity="1.000000" stroke="none"
        d="
M667.701660,130.501404
	C668.214478,128.746872 668.286743,126.958969 669.087952,125.601257
	C669.991089,124.070915 671.468689,121.924057 672.840576,121.812149
	C676.395081,121.522194 680.032471,122.174217 683.614380,122.627045
	C683.727478,122.641335 683.733948,125.484001 683.556824,125.511604
	C680.899414,125.925896 678.172241,126.440529 675.523926,126.210968
	C672.885559,125.982277 670.823120,125.784058 670.761292,128.007278
	C672.202332,130.313919 673.097351,131.746582 673.991577,133.558136
	C673.990723,133.937027 673.504272,133.950912 673.263062,133.918152
	C671.419128,132.941986 669.816406,131.998550 667.831299,131.041153
	C667.448853,131.027191 667.583008,130.657928 667.701660,130.501404
z"/>
      {/* <path fill="black" opacity="1.000000" stroke="none"
        d="
M459.613525,274.737732
	C458.889709,278.508362 457.114990,280.634674 453.384583,279.738342
	C449.905212,278.902283 449.540253,276.006866 449.722412,273.071320
	C449.905365,270.122772 451.196442,267.892365 454.519440,267.936066
	C458.698059,267.990967 459.558685,270.920441 459.613525,274.737732
z"/> */}
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M258.751831,271.215973
	C258.925659,272.118744 258.850098,272.816193 258.547119,273.783478
	C258.380646,273.039093 258.441559,272.024872 258.751831,271.215973
z"/> */}
      {/* <path fill="#B5B5B5" opacity="1.000000" stroke="none"
        d="
M268.785004,271.805267
	C268.484802,272.088898 268.305603,272.070770 267.921265,271.876831
	C268.112732,271.635193 268.509369,271.569366 268.785004,271.805267
z"/> */}
      {/* <path fill="black" opacity="1.000000" stroke="none"
        d="
M313.488983,268.271851
	C314.173950,269.540863 314.909851,271.515045 314.655884,271.651855
	C313.097748,272.491302 311.315643,272.914978 309.188049,273.615387
	C309.188049,271.322784 309.188049,269.907654 309.188049,268.127808
	C310.572815,268.127808 311.827606,268.127808 313.488983,268.271851
z"/> */}
      {/* <path fill="black" opacity="1.000000" stroke="none"
        d="
M385.991882,272.426514
	C385.923035,270.880463 385.923035,269.742554 385.923035,267.636047
	C387.985596,268.263306 389.783600,268.586334 391.303894,269.417358
	C391.725861,269.647980 391.526428,272.232574 391.267273,272.294586
	C389.584839,272.696686 387.807220,272.700439 385.991882,272.426514
z"/> */}
      {/* <path fill="#E9DEC8" opacity="1.000000" stroke="none"
        d="
M473.611877,270.141602
	C471.933228,271.670746 470.159210,272.814911 467.439087,274.569275
	C467.439087,271.412170 467.439087,269.995972 467.439087,267.372986
	C469.739746,268.275360 471.628113,269.015991 473.611877,270.141602
z"/> */}
      <path fill="#D28E2D" opacity="1.000000" stroke="none"
        d="
M669.671265,158.435699
	C669.899414,158.390198 670.112610,158.591064 670.164795,158.912292
	C670.003723,159.032684 669.656250,158.682037 669.671265,158.435699
z"/>
      <path fill="#E59E50" opacity="1.000000" stroke="none"
        d="
M737.301025,138.882904
	C737.452209,137.779312 737.848450,136.453506 738.606262,135.060120
	C738.493958,136.215271 738.019958,137.437988 737.301025,138.882904
z"/>
      <path fill="#C1AB80" opacity="1.000000" stroke="none"
        d="
M9.715753,115.232986
	C10.367970,119.031181 10.918335,123.108414 6.574717,125.990829
	C7.312973,122.547600 8.378843,119.005852 9.715753,115.232986
z"/>
      <path fill="#E9B274" opacity="1.000000" stroke="none"
        d="
M728.292297,158.901855
	C728.201477,158.480484 728.371338,157.902237 728.819458,157.181793
	C728.916138,157.608063 728.734497,158.176514 728.292297,158.901855
z"/>
      <path fill="#C1AB80" opacity="1.000000" stroke="none"
        d="
M48.308418,95.935493
	C48.776981,94.696838 49.528862,93.353180 50.669785,92.020126
	C51.026737,92.448074 50.994644,92.865410 50.923119,93.594292
	C50.119705,94.547386 49.355721,95.188934 48.308418,95.935493
z"/>
      <path fill="#3485BC" opacity="1.000000" stroke="none"
        d="
M657.770264,128.978073
	C652.816101,124.118767 652.427673,118.048386 656.724548,112.635719
	C660.860168,107.426163 667.468506,106.041718 672.573853,109.651009
	C667.194824,110.585014 661.928955,111.586678 659.877258,117.043312
	C658.479797,120.760208 658.425232,124.982025 657.770264,128.978073
z"/>
      <path fill="#857760" opacity="1.000000" stroke="none"
        d="
M657.945557,129.273804
	C658.425232,124.982025 658.479797,120.760208 659.877258,117.043312
	C661.928955,111.586678 667.194824,110.585014 672.792358,109.940445
	C674.268127,110.875839 675.332336,111.897987 676.697998,113.425598
	C678.119690,116.395561 679.544373,116.258446 680.997681,114.292870
	C682.344971,112.470604 683.550598,110.543541 684.916504,108.968163
	C685.061584,109.480652 685.108948,109.687607 685.074646,110.258316
	C684.254761,112.711327 683.516541,114.800568 682.504517,116.928856
	C681.807373,117.298111 681.384155,117.628304 680.960938,117.958504
	C679.349121,117.900070 677.737244,117.841629 675.672607,117.405533
	C675.135498,116.354370 675.051147,115.680870 674.839111,114.669281
	C672.281616,110.252090 667.976868,111.821320 666.186646,113.429405
	C663.533569,115.812515 659.091614,117.936127 660.088379,123.390625
	C659.411865,127.392059 660.078186,130.271057 664.104858,131.346939
	C661.139648,134.022034 659.961548,130.680450 657.945557,129.273804
z"/>
      <path fill="#3485BC" opacity="1.000000" stroke="none"
        d="
M684.818604,108.662598
	C683.550598,110.543541 682.344971,112.470604 680.997681,114.292870
	C679.544373,116.258446 678.119690,116.395561 676.973755,113.612267
	C678.657104,108.944206 680.366150,104.594925 682.113953,99.901886
	C682.725098,99.388016 683.297546,99.217918 684.522400,99.096893
	C686.129272,99.731903 687.083618,100.317848 687.986328,101.199448
	C687.972656,101.890900 688.010620,102.286690 687.852417,102.987747
	C686.710327,105.082863 685.764465,106.872719 684.818604,108.662598
z"/>
      <path fill="#D28E2D" opacity="1.000000" stroke="none"
        d="
M664.406677,131.272766
	C660.078186,130.271057 659.411865,127.392059 660.393433,123.225067
	C664.962952,119.144539 668.773193,114.853310 674.966797,115.007378
	C675.051147,115.680870 675.135498,116.354370 675.273926,117.356522
	C674.107971,118.118744 672.919189,118.710381 671.662598,118.958900
	C665.833191,120.111732 663.705444,123.798225 665.843018,129.901093
	C665.650818,130.472305 665.179688,130.835434 664.406677,131.272766
z"/>
      <path fill="#E59E50" opacity="1.000000" stroke="none"
        d="
M700.705017,72.034798
	C701.300049,72.827034 701.589111,73.513603 701.995361,74.866379
	C703.263489,77.512444 709.594299,79.359009 713.063232,78.726669
	C713.374329,79.174049 713.685364,79.621422 713.961975,80.735031
	C709.379578,91.689178 701.173828,93.809570 691.940308,87.269424
	C691.321960,86.831436 689.643738,87.889900 688.359497,88.328911
	C688.154053,88.545609 688.101868,88.703804 687.929199,88.997368
	C687.754395,89.114693 687.334778,89.149254 687.117798,88.846329
	C685.934753,87.332001 684.968567,86.120583 684.002441,84.909172
	C683.978149,83.916718 683.953857,82.924255 683.915649,81.565918
	C684.489380,80.536781 685.077026,79.873520 685.664612,79.210266
	C686.332336,80.584694 687.000122,81.959122 687.458862,82.903374
	C691.873169,83.915215 696.708801,86.491974 699.674561,81.281197
	C700.220154,80.322556 697.997009,77.788055 696.891907,75.675133
	C697.159424,74.732361 697.595886,73.194328 698.075562,71.280205
	C698.878906,71.245781 699.638977,71.587456 700.705017,72.034798
z"/>
      <path fill="#B469E7" opacity="1.000000" stroke="none"
        d="
M688.458374,88.252350
	C689.643738,87.889900 691.321960,86.831436 691.940308,87.269424
	C701.173828,93.809570 709.379578,91.689178 713.998657,81.014786
	C714.069885,80.628311 714.448608,80.785629 714.652527,80.796844
	C716.187988,84.170860 713.115906,89.756691 708.374634,91.587830
	C705.937439,92.529068 704.386597,92.585518 704.323425,96.254219
	C704.278503,98.863220 700.699341,101.411392 697.994873,103.838120
	C694.207520,102.760941 691.122742,101.832367 688.038025,100.903793
	C687.083618,100.317848 686.129272,99.731903 684.825317,99.073425
	C685.336426,96.609970 686.197083,94.219040 687.143921,91.126472
	C687.222229,89.982513 687.214294,89.540184 687.235413,89.118515
	C687.264404,89.139168 687.334778,89.149254 687.334778,89.149254
	C687.334778,89.149254 687.754395,89.114693 687.980957,89.170166
	C688.291138,88.901207 688.374756,88.576775 688.458374,88.252350
z"/>
      <path fill="#D28E2D" opacity="1.000000" stroke="none"
        d="
M683.987671,85.310287
	C684.968567,86.120583 685.934753,87.332001 687.117798,88.846329
	C687.334778,89.149254 687.264404,89.139168 686.939941,89.229492
	C686.409302,89.891434 686.203125,90.463043 685.996887,91.034668
	C684.545349,93.132927 683.093750,95.231171 681.642151,97.329422
	C681.221802,97.036835 680.801514,96.744255 680.381165,96.451675
	C681.578430,92.871582 682.775635,89.291489 683.987671,85.310287
z"/>
      <path fill="#E59E50" opacity="1.000000" stroke="none"
        d="
M686.261719,91.036697
	C686.203125,90.463043 686.409302,89.891434 686.911011,89.208839
	C687.214294,89.540184 687.222229,89.982513 687.142578,90.749146
	C686.878906,91.061882 686.702759,91.050316 686.261719,91.036697
z"/>
      <path fill="#AA44DF" opacity="1.000000" stroke="none"
        d="
M694.964294,125.021744
	C696.637512,124.069321 698.266968,123.024734 700.001831,122.202400
	C700.903320,121.775093 702.486511,121.207916 702.918518,121.609978
	C707.755005,126.110733 710.378784,122.295570 713.711182,119.243340
	C714.562012,119.636993 714.901672,119.854568 715.078064,120.317963
	C712.593445,129.315567 705.801819,132.511612 696.974365,128.659882
	C696.265747,127.234329 695.614990,126.128044 694.964294,125.021744
z"/>
      <path fill="#A93B64" opacity="1.000000" stroke="none"
        d="
M697.032227,128.979156
	C705.801819,132.511612 712.593445,129.315567 715.272705,120.130005
	C716.303772,117.560791 716.976990,115.425346 717.678528,113.199852
	C720.823181,113.855927 723.852417,114.487923 726.881653,115.119919
	C727.067871,115.153046 727.254028,115.186165 727.721802,115.256027
	C728.730713,116.202065 729.457947,117.111343 730.207153,118.310776
	C727.842285,118.069519 725.323608,117.855736 723.099304,116.932678
	C719.712891,115.527412 718.477844,116.180588 717.868225,119.974060
	C716.321289,129.599670 707.866333,134.427460 698.318970,131.267105
	C697.315918,130.725708 696.666809,130.263489 696.216187,129.441803
	C696.620544,129.047958 696.826416,129.013565 697.032227,128.979156
z"/>
      <path fill="#B469E7" opacity="1.000000" stroke="none"
        d="
M725.370239,80.366302
	C724.360779,81.998550 723.766052,83.475822 722.959717,84.826836
	C722.014343,86.410835 720.885071,87.885048 719.835571,89.406876
	C719.284302,89.139038 718.733093,88.871208 718.181824,88.603371
	C718.520630,84.455872 718.573486,80.249870 719.401672,76.202507
	C719.605652,75.205658 722.291260,74.315765 723.917236,74.143456
	C725.116943,74.016335 726.448730,75.135460 727.721680,75.699287
	C727.044861,77.184677 726.368103,78.670074 725.370239,80.366302
z"/>
      <path fill="#9129B3" opacity="1.000000" stroke="none"
        d="
M726.839478,114.750320
	C723.852417,114.487923 720.823181,113.855927 717.678528,113.199852
	C716.976990,115.425346 716.303772,117.560791 715.435913,119.884186
	C714.901672,119.854568 714.562012,119.636993 714.041748,119.170670
	C713.726440,115.860367 713.591919,112.798813 713.422119,108.935852
	C718.064026,110.825523 722.430664,112.603119 726.839478,114.750320
z"/>
      <path fill="#AD56A4" opacity="1.000000" stroke="none"
        d="
M687.986328,101.199448
	C691.122742,101.832367 694.207520,102.760941 697.613647,103.848419
	C697.363220,104.492798 696.791382,104.978294 695.853638,105.832069
	C695.236450,106.415871 695.080322,106.686417 695.019470,107.011993
	C693.354065,108.983208 691.688599,110.954430 689.573120,112.620720
	C689.872742,111.147926 690.622559,109.980057 691.583984,108.608170
	C692.500977,107.165016 693.206360,105.925888 694.196411,104.186829
	C691.812866,103.603592 689.930725,103.143036 688.048584,102.682480
	C688.010620,102.286690 687.972656,101.890900 687.986328,101.199448
z"/>
      <path fill="#AD56A4" opacity="1.000000" stroke="none"
        d="
M696.974365,128.659882
	C696.826416,129.013565 696.620544,129.047958 696.108276,129.152023
	C690.492554,126.746887 687.784790,122.674370 688.251709,116.117966
	C688.577820,115.233223 688.849121,115.073242 689.188477,115.028397
	C690.477173,118.534912 689.887085,123.003380 694.611572,124.976547
	C695.614990,126.128044 696.265747,127.234329 696.974365,128.659882
z"/>
      <path fill="#DA7D2A" opacity="1.000000" stroke="none"
        d="
M689.164429,114.690918
	C688.849121,115.073242 688.577820,115.233223 688.230164,115.698395
	C686.962219,116.243912 685.838623,116.599350 684.054321,116.962105
	C683.188477,116.942871 682.983398,116.916336 682.778320,116.889801
	C683.516541,114.800568 684.254761,112.711327 685.400757,110.228210
	C687.889954,110.728432 688.771118,105.088707 691.372375,108.812202
	C690.622559,109.980057 689.872742,111.147926 689.253662,112.670944
	C689.303040,113.468544 689.221741,113.910988 689.164429,114.690918
z"/>
      <path fill="#B469E7" opacity="1.000000" stroke="none"
        d="
M708.863281,94.832123
	C711.382874,93.254204 713.664246,91.940620 715.945618,90.627029
	C716.365784,91.349197 716.785889,92.071365 717.205994,92.793526
	C714.800171,94.185028 712.407227,95.601151 709.943665,96.881531
	C709.841003,96.934830 709.079529,95.720322 708.863281,94.832123
z"/>
      <path fill="#B469E7" opacity="1.000000" stroke="none"
        d="
M718.189514,104.817062
	C717.415100,104.059158 716.995422,103.336571 716.575745,102.613983
	C717.460449,102.540833 718.345215,102.467690 719.229919,102.394539
	C719.001343,103.213821 718.772766,104.033104 718.189514,104.817062
z"/>
      <path fill="#B469E7" opacity="1.000000" stroke="none"
        d="
M715.419556,78.965469
	C715.062012,77.958054 715.038635,76.871750 715.086670,75.383194
	C715.356567,76.282822 715.555115,77.584694 715.419556,78.965469
z"/>
      <path fill="#B469E7" opacity="1.000000" stroke="none"
        d="
M695.256714,106.998756
	C695.080322,106.686417 695.236450,106.415871 695.686401,106.070541
	C695.754639,106.288986 695.624329,106.637253 695.256714,106.998756
z"/>
      <path fill="#DA7D2A" opacity="1.000000" stroke="none"
        d="
M713.077148,78.359604
	C709.594299,79.359009 703.263489,77.512444 702.167236,75.099823
	C706.258484,74.424225 711.168213,71.327194 713.077148,78.359604
z"/>
      <path fill="#D28E2D" opacity="1.000000" stroke="none"
        d="
M682.504456,116.928848
	C682.983398,116.916336 683.188477,116.942871 683.702881,116.995338
	C683.937195,118.083313 683.862244,119.145363 683.731628,120.995705
	C682.511536,119.899910 681.791748,119.253441 681.016479,118.282730
	C681.384155,117.628304 681.807373,117.298111 682.504456,116.928848
z"/>
      <path fill="#E89E3F" opacity="1.000000" stroke="none"
        d="
M707.108765,147.852982
	C704.726868,146.942917 702.731323,146.103867 699.478333,144.736069
	C703.024292,142.957672 704.861084,142.036469 707.190735,140.868088
	C707.333862,143.419495 713.200745,145.033585 707.108765,147.852982
z"/>
      <path fill="#DA7D2A" opacity="1.000000" stroke="none"
        d="
M674.839111,114.669281
	C668.773193,114.853310 664.962952,119.144539 660.422180,122.807693
	C659.091614,117.936127 663.533569,115.812515 666.186646,113.429405
	C667.976868,111.821320 672.281616,110.252090 674.839111,114.669281
z"/>
      <path fill="#A93B64" opacity="1.000000" stroke="none"
        d="
M691.583984,108.608170
	C688.771118,105.088707 687.889954,110.728432 685.482422,109.864441
	C685.108948,109.687607 685.061584,109.480652 684.916443,108.968140
	C685.764465,106.872719 686.710327,105.082863 687.852417,102.987747
	C689.930725,103.143036 691.812866,103.603592 694.196411,104.186829
	C693.206360,105.925888 692.500977,107.165016 691.583984,108.608170
z"/>
      <path fill="#B5975A" opacity="1.000000" stroke="none"
        d="
M688.359497,88.328903
	C688.374756,88.576775 688.291138,88.901207 688.155701,89.052841
	C688.101868,88.703804 688.154053,88.545609 688.359497,88.328903
z"/>
    </svg>
  )
};

export default LogoFull;
